export default {
  // Member Churn List
  'memberChurn.title': 'Lista de Abandono de Miembros',
  'memberChurn.vipLevels': 'Niveles VIP',
  'memberChurn.caliberDescription': 'Descripción de Calibre',
  'memberChurn.search': 'Buscar',
  'memberChurn.reset': 'Restablecer',
  'memberChurn.export': 'Exportar',
  'memberChurn.memberAccount': 'Cuenta de Miembro',
  'memberChurn.realName': 'Nombre Real del Miembro',
  'memberChurn.memberName': 'Apodo del Miembro',
  'memberChurn.agentAccount': 'Cuenta de Agente Superior',
  'memberChurn.registerInfo': 'Información de Registro',
  'memberChurn.registerTime': 'Hora de Registro',
  'memberChurn.registerIp': 'IP de Registro',
  'memberChurn.rechargeCount': 'Cantidad de Depósitos',
  'memberChurn.withdrawCount': 'Cantidad de Retiros',
  'memberChurn.totalRecharge': 'Depósito Total (Multimoneda)',
  'memberChurn.totalWithdraw': 'Retiro Total',
  'memberChurn.firstRechargeTime': 'Hora del Primer Depósito',
  'memberChurn.lastRechargeTime': 'Última Hora de Depósito',
  'memberChurn.lastRechargeStartTime': 'Última Hora de Depósito (Inicio)',
  'memberChurn.lastRechargeEndTime': 'Última Hora de Depósito (Fin)',
'memberChurn.lastLoginTime': 'Última Hora de Inicio de Sesión',
'memberChurn.lastBettingTime': 'Última Hora de Apuesta',
  'memberChurn.action': 'Acción',
  'memberChurn.view': 'Ver',
  'memberChurn.noData': 'Sin datos',
  'memberChurn.defaultEmpty': 'Seleccione condiciones de búsqueda',
  'memberChurn.requestFailed': 'La solicitud falló',
  'memberChurn.export.loading': 'Exportando datos...',
  'memberChurn.export.needDataFirst': 'Busque los datos primero',
  'memberChurn.export.noDataWarning': 'Busque los datos antes de exportar',
  'memberChurn.export.success': 'Exportación exitosa',
  'memberChurn.export.failed': 'Falló la exportación',
  'memberChurn.timeRangeWarning': 'Seleccione rango de tiempo',
  'memberChurn.startTime': 'Hora de Depósito Reciente (Inicio)',
  'memberChurn.endTime': 'Hora de Depósito Reciente (Fin)',
  'memberChurn.timeRangeError': 'La hora de inicio no puede ser posterior a la hora de fin',
  'memberChurn.depositTimeQueryTip': '[Se recomienda seleccionar la hora de depósito reciente para consultar primero]',
  'memberChurn.caliberTooltip': 'Calibre de Abandono: Solo se juzga por depósito. Filtra usuarios cuyo "último depósito exitoso cae dentro del período de tiempo seleccionado y no han tenido nuevos depósitos desde entonces"; Visualización predeterminada: Usuarios que no han depositado durante 3 días (fecha de fin = hoy - 3 días, fecha de inicio en blanco); Uso común: Solo completar "fecha de fin" → Encontrar usuarios cuyo "último depósito ≤ esa fecha y sin nuevo depósito hasta ahora"; Completar ambos "inicio + fin" → Encontrar usuarios cuyo "último depósito está dentro del rango y sin nuevo depósito hasta ahora"; Solo completar "fecha de inicio" → Encontrar usuarios cuyo "último depósito ≥ esa fecha y sin nuevo depósito hasta ahora"; Ejemplo: Hoy 8/27, seleccionar fecha de fin 8/24 → Filtrar usuarios cuyo último depósito fue en o antes del 8/24 y sin depósito del 8/25–8/27. Seleccionar rango de tiempo 8/1–8/7 → Filtrar usuarios cuyo último depósito fue entre 8/1–8/7 y sin depósito del 8/8–8/27. Nota: Inicio de sesión/apuesta no afecta el juicio de abandono.',
  'member.detail.search.memberAccount': 'Cuenta de Miembro',
  'member.detail.search.placeholder': 'Ingrese cuenta de miembro / teléfono / correo',
  'member.detail.search.button': 'Buscar',
  'member.detail.search.refresh': 'Actualizar',
  'member.detail.search.notFound': 'Información de miembro no encontrada',
  'member.detail.search.error': 'Error de servicio',
  'member.detail.tabs.basicInfo': 'Información Básica',
  'member.detail.tabs.accountInfo': 'Información de Cuenta',
  'member.detail.tabs.mainAccountTrade': 'Operación de Cuenta Principal',
  'member.detail.tabs.recentBets': 'Apuestas Recientes',
  'member.detail.tabs.promotionInfo': 'Información de Promoción',
  'member.detail.tabs.memberPoints': 'Puntos de Miembro',
  'member.detail.tabs.gameAccountTrade': 'Operación de Cuenta de Juego',
  'member.detail.tabs.riskControl': 'Información de Control de Riesgo',
  'member.detail.tabs.badDebt': 'Registros de Deuda Incobrable',
  'member.detail.tabs.regulatoryReport': 'Estado de Ruta de Juego',
  'member.detail.regulatoryReport.statusLabel': 'Estado',
  'member.detail.regulatoryReport.statusReporting': 'Reportando',
  'member.detail.regulatoryReport.statusClosed': 'Reporte cerrado',
  'member.detail.regulatoryReport.closeButton': 'Deshabilitar reporte de datos',
  'member.detail.regulatoryReport.closeButtonHint': 'Los requisitos previos se verifican en tiempo real cuando se hace clic',
  'member.detail.regulatoryReport.precheckTitle': 'Verificación previa antes de cerrar reporte',
  'member.detail.regulatoryReport.precheckBanner': 'Se detectaron los siguientes problemas; no se permite cerrar:',
  'member.detail.regulatoryReport.precheckOk': 'De acuerdo, intente más tarde',
  'member.detail.regulatoryReport.check.deposit.ok': 'Sin órdenes de depósito pendientes',
  'member.detail.regulatoryReport.check.deposit.fail': 'El usuario tiene órdenes de depósito pendientes, intente más tarde',
  'member.detail.regulatoryReport.check.withdraw.ok': 'Sin órdenes de retiro de pago pendientes',
  'member.detail.regulatoryReport.check.withdraw.fail': 'El usuario tiene órdenes de retiro de pago pendientes, intente más tarde',
  'member.detail.regulatoryReport.check.unsettledBet.ok': 'Sin órdenes de apuesta pendientes de liquidación',
  'member.detail.regulatoryReport.check.unsettledBet.fail': 'El usuario tiene órdenes de apuesta pendientes de liquidación, intente más tarde',
  'member.detail.regulatoryReport.check.recentBet.ok': 'Sin actividad de juego en progreso (sin apuestas en los últimos 10 minutos)',
  'member.detail.regulatoryReport.check.recentBet.fail': 'El usuario tiene apuestas en los últimos 10 minutos, intente más tarde',
  'member.detail.regulatoryReport.ordersDetail': 'Número de orden: {orders}',
  'member.detail.regulatoryReport.reasonTitle': 'Razón para cerrar reporte',
  'member.detail.regulatoryReport.reasonPlaceholder': 'Ingrese la razón',
  'member.detail.regulatoryReport.reasonRequired': 'Ingrese una razón',
  'member.detail.regulatoryReport.confirmClose': 'Confirmar cierre',
  'member.detail.regulatoryReport.applySuccess': 'Reporte de datos ha sido deshabilitado',
  'member.detail.regulatoryReport.applyFail': 'Falló al cerrar',
  'member.detail.regulatoryReport.precheckFail': 'Verificación previa falló',

  'member.closeReportUser.title': 'Registro de Cambios de Ruta de Juego',
  'member.closeReportUser.subtitle': 'Solo se enumeran usuarios cuyo reporte de datos PAGCOR ha sido cerrado; se admite exportación.',
  'member.closeReportUser.memberAccount': 'Cuenta de miembro',
  'member.closeReportUser.memberAccountPh': 'Cuenta de miembro',
  'member.closeReportUser.closeTimeRange': 'Tiempo de cierre de reporte',
  'member.closeReportUser.closeTime': 'Tiempo de cierre de reporte',
  'member.closeReportUser.operatorName': 'Operador',
  'member.closeReportUser.operatorPh': 'Cuenta de operador',
  'member.closeReportUser.operationReason': 'Razón de la operación',

  'member.reportStatus.detail.title': 'Estado de Reporte',
  'member.reportStatus.detail.currentTitle': 'Estado Actual',
  'member.reportStatus.detail.currentStatus': 'Estado_reporte actual',
  'member.reportStatus.detail.latestSwitch': 'Último Cambio',
  'member.reportStatus.detail.switchReason': 'Razón del Cambio',
  'member.reportStatus.detail.toggleBtn': 'Cambiar Ruta de Juego',
  'member.reportStatus.detail.historyTitle': 'Historial de Cambios',
  'member.reportStatus.col.time': 'Hora',
  'member.reportStatus.col.type': 'Tipo',
  'member.reportStatus.col.statusChange': 'Cambio de Estado',
  'member.reportStatus.col.operator': 'Operador',
  'member.reportStatus.col.reason': 'Razón',
  'member.reportStatus.col.remark': 'Observación',
  'member.reportStatus.status.reported': 'Ruta A',
  'member.reportStatus.status.notReported': 'Ruta B',
  'member.reportStatus.type.registerAuto': 'Automático (Registro)',
  'member.reportStatus.type.manual': 'Manual',
  'member.reportStatus.type.autoThreshold': 'Depósito Alcanzado',
  'member.reportStatus.type.autoVip': 'VIP Alcanzado',
  'member.reportStatus.reasonLabel.REGISTER_AUTO': 'Etiquetado por proporción de registro',
  'member.reportStatus.reasonLabel.AUTO_THRESHOLD': 'Depósito acumulado alcanzado',
  'member.reportStatus.reasonLabel.AUTO_VIP': 'Nivel VIP alcanzado',
  'member.reportStatus.modal.title': 'Cambiar Ruta de Juego',
  'member.reportStatus.modal.memberAccount': 'Cuenta de Miembro',
  'member.reportStatus.modal.statusChange': 'Cambio de Estado',
  'member.reportStatus.modal.reason': 'Razón del Cambio',
  'member.reportStatus.modal.remark': 'Observación',
  'member.reportStatus.modal.remarkPh': 'Razón detallada opcional para auditoría',
  'member.reportStatus.modal.reasonPh': 'Requerido. Indique la razón (p. ej. cuenta de prueba interna / reciclaje de cuenta / usuario mal incorporado / aprobación especial, etc.)',
  'member.reportStatus.modal.confirm': 'Confirmar',
  'member.reportStatus.modal.cancel': 'Cancelar',
  'member.reportStatus.modal.reasonRequired': 'Seleccione una razón de cambio',
  'member.reportStatus.modal.backupTip': 'Después de cambiar, el sistema hará una copia de seguridad del registro_apuesta actual del usuario a registro_apuesta_bak (para auditoría). Efectivo desde la siguiente ronda de juego.',
  'member.reportStatus.reason.arbitrage': 'Cuenta de arbitraje confirmada',
  'member.reportStatus.reason.channel': 'Conflicto de atribución de canal',
  'member.reportStatus.reason.internal': 'Cuenta de prueba interna',
  'member.reportStatus.reason.riskUser': 'Usuario de control de riesgo',
  'member.reportStatus.reason.other': 'Otro (agregue observación)',
  'member.reportStatus.toggleSuccess': 'Cambiado exitosamente',
  'member.reportStatus.toggleFail': 'Falló el cambio',
  'member.reportStatus.fetchError': 'Falló al cargar',
  'member.reportStatus.list.title': 'Gestión de Estado de Reporte',
  'member.reportStatus.list.subtitle': 'Se muestran aquí miembros cerrados automáticamente al registro y modificados manualmente.',
  'member.reportStatus.list.statusAll': 'Todos',
  'member.reportStatus.list.memberAccount': 'Cuenta de Miembro',
  'member.reportStatus.list.status': 'Estado Actual',
  'member.reportStatus.list.switchTimeRange': 'Última Hora de Cambio',
  'member.reportStatus.list.switchTime': 'Última Hora de Cambio',
  'member.reportStatus.list.operator': 'Operador',
  'member.reportStatus.list.reason': 'Razón del Cambio',
  'member.reportStatus.list.detail': 'Detalle',
  'member.reportStatus.list.search': 'Buscar',
  'member.reportStatus.list.reset': 'Restablecer',
  'member.reportStatus.list.export': 'Exportar',

  'member.detail.index.summary': 'Información de Resumen',
  'member.detail.index.lastLogin': 'Últimos 10 Inicios de Sesión',
  'member.detail.index.certification': 'Documentos de Certificación',
  'member.detail.index.vipInfo': 'Información VIP',
  'member.detail.index.manualTags': 'Etiquetas de Miembro',
  'member.detail.index.remarks': 'Observaciones',
  'member.detail.modal.addRemark.title': 'Agregar Nota',
  'member.detail.modal.agent.title': 'Modificar Agente Superior',
  'member.detail.modal.agent.currentAgent': 'Agente Superior Actual:',
  'member.detail.modal.agent.operationType': 'Seleccione Tipo de Operación:',
  'member.detail.modal.agent.modifyAgent': 'Modificar Agente Superior',
  'member.detail.modal.agent.removeAgent': 'Eliminar Agente Superior',
  'member.detail.modal.agent.targetAgent': 'Agente Destino:',
  'member.detail.modal.agent.remark': 'Observación:',
  'member.detail.modal.agent.cancel': 'Cancelar',
  'member.detail.modal.agent.confirm': 'Confirmar',
  'member.detail.modal.agent.inputPlaceholder': 'Ingrese',
  'member.detail.modal.agent.agentNotExist': '¡Agente especificado no existe!',
  'member.detail.modal.agent.inputAgentAccount': 'Ingrese cuenta de agente',
  'member.detail.modal.agent.success': 'Operación exitosa',
  'member.detail.modal.agent.error': 'Operación falló',
  'member.detail.modal.inviter.title': 'Agregar Patrocinador',
  'member.detail.modal.inviter.currentInviter': 'Patrocinador Actual:',
  'member.detail.modal.inviter.operationType': 'Seleccione Tipo de Operación:',
  'member.detail.modal.inviter.selectOperationType': 'Seleccione tipo de operación',
  'member.detail.modal.inviter.modifyInviter': 'Modificar Patrocinador',
  'member.detail.modal.inviter.removeInviter': 'Eliminar Patrocinador',
  'member.detail.modal.inviter.targetInviter': 'Especifique Patrocinador:',
  'member.detail.modal.inviter.inputInviterAccount': 'Ingrese cuenta de patrocinador',
  'member.detail.modal.inviter.inputPlaceholder': 'Ingrese',
  'member.detail.modal.inviter.inputHint': 'Puede ingresar la cuenta de patrocinador/UID',
  'member.detail.modal.inviter.remark': 'Observaciones/Notas:',
  'member.detail.modal.inviter.cancel': 'Cancelar',
  'member.detail.modal.inviter.confirm': 'Confirmar',
  'member.detail.modal.inviter.success': 'Operación exitosa',
  'member.detail.modal.inviter.error': 'Operación falló',
  'member.detail.modal.inviter.inviterNotExist': 'Patrocinador no existe',
  'member.detail.modal.inviter.noInviter': 'Sin Patrocinador',

  // Member List Page
  'memberList.title': 'Lista de Miembros',
  'memberList.searchWarning': 'Debido al gran volumen de datos, combine 1 o más condiciones para consultar datos',
  'memberList.exportWarning': 'Seleccione al menos 3 condiciones de consulta para exportar',
  'memberList.timeConditionWarning': 'Cuando seleccione hora del primer depósito u última hora de depósito, también seleccione moneda',
  'memberList.dataExceedWarning': 'Los datos de su consulta han excedido 1000 elementos, use la función de exportación para exportar los datos que necesita',
  'memberList.exportExceedWarning': 'Sus datos de exportación han excedido 10000 elementos, ajuste las condiciones de filtro',
  'memberList.notes': 'La página no tiene datos de forma predeterminada, la tabla muestra sin datos',
  'memberList.defaultEmpty': 'Sin datos',
  'memberList.registerTime': 'Hora de Registro',
  'memberList.firstRechargeTime': 'Hora del Primer Depósito',
  'memberList.lastRechargeTime': 'Última Hora de Depósito',
  'memberList.lastLoginTime': 'Última Hora de Inicio de Sesión',
  'memberList.mobileProvider': 'Proveedor Móvil',
  'memberList.mobileProviderPlaceholder': 'Seleccione Proveedor Móvil',
  'memberList.mobileValid': 'Estado de Verificación Móvil',
  'memberList.mobileValidPlaceholder': 'Seleccione estado de verificación móvil',
  'memberList.mobileValid.verified': 'Verificado',
  'memberList.mobileValid.unverified': 'No Verificado',
  'memberList.isAgent': 'Tiene Sala de Juegos Superior',
  'memberList.hasAgent': 'Tiene Sala de Juegos',
  'memberList.noAgent': 'Sin Sala de Juegos',
  'memberList.agentAccount': 'Cuenta de Sala de Juegos',
  'memberList.agentType': 'Tipo de Sala de Juegos',
  'memberList.agentTag': 'Etiqueta de Sala de Juegos',
  'memberList.topAgent': 'Sala de Juegos de Nivel Superior',
  'memberList.agentAccountAllUnderL1': 'Todos bajo este L1',
  'memberList.agentAccountSelectL1First': 'Seleccione primero una sala de juegos de nivel superior',
  'memberList.defaultAgent': 'Agente Predeterminado',
  'memberList.realName': 'Nombre Real del Miembro',
  'memberList.memberAccount': 'Cuenta de Miembro',
  'memberList.memberName': 'Apodo del Miembro',
  'memberList.vipLevels': 'Niveles VIP',
  'memberList.validInfos': 'Información de Verificación',
  'memberList.risks': 'Niveles de Riesgo',
  'memberList.manualTags': 'Etiquetas Manuales',
  'memberList.manualTagsPlaceholder': 'Seleccione etiquetas de miembro',
  'memberList.autoTags': 'Etiquetas Automáticas',
  'memberList.userTags': 'Etiquetas de Miembro',
  'memberList.userTagsPlaceholder': 'Seleccione una etiqueta',
  'memberList.loginLimit': 'Límite de Inicio de Sesión',
  'memberList.loginLimitType': 'Tipo de Límite de Inicio de Sesión',
  'memberList.loginLimitTypePlaceholder': 'Seleccione tipo de límite de inicio de sesión',
  'memberList.loginLimitType.passwordError': 'Error de Contraseña de Inicio de Sesión',
  'memberList.vipLevel': 'Nivel de Miembro',
  'memberList.registerInfo': 'Información de Registro',
  'memberList.registerIp': 'IP de Registro',
  'memberList.mainBalance': 'Saldo de Cuenta Principal',
  'memberList.rechargeCount': 'Cantidad de Depósitos',
  'memberList.withdrawCount': 'Cantidad de Retiros',
  'memberList.totalRecharge': 'Depósito Total',
  'memberList.totalWithdraw': 'Retiro Total',
  'memberList.validInfo': 'Información de Verificación',
  'memberList.memberPoints': 'Puntos de Miembro',
  'memberList.riskLevel': 'Nivel de Riesgo',
  'memberList.currency': 'Moneda',
  'memberList.startDate': 'Fecha de Inicio',
  'memberList.endDate': 'Fecha de Fin',
  'memberList.search': 'Buscar',
  'memberList.reset': 'Restablecer',
  'memberList.export': 'Exportar',
  'memberList.export.loading': 'Exportando...',
  'memberList.export.success': 'Exportación exitosa',
  'memberList.requestFailed': 'La solicitud falló',
  'memberList.action': 'Acción',
  'memberList.view': 'Ver',
  'memberList.batchSetRisk': 'Establecer Riesgo en Lote',
  'memberList.noData': 'Sin datos',
  'memberList.upload.selected': 'Borrar archivo seleccionado',
  'memberList.upload.running': 'Cargando',
  'memberList.upload.success': 'Carga exitosa',
  'memberList.upload.failed': 'Carga falló',
  'memberList.upload.file.size': 'El archivo no puede exceder 2GB',
  'memberList.upload.title': 'Cargar CSV de información de miembro',
  'memberList.upload.selected.area': 'Haga clic o arrastre el archivo a esta área para cargar',
  'memberList.upload.selected.area.bottom': 'Solo se admiten archivos CSV, con un tamaño máximo de 40MB. Los nombres de campos deben cumplir con los requisitos del servidor. Las columnas de encabezado incluyen: nombre de usuario, fecha de nacimiento, tipo de usuario, versión, ...; tipo de usuario admite NORMAL / STORE, y los usuarios de tienda requieren versión: V1 / V2.',
  'memberList.upload.button': 'Cargar',

  // Verification info options
  'memberList.validInfo.realName': 'Verificación de Nombre Real',
  'memberList.validInfo.mobile': 'Verificación Móvil',
  'memberList.validInfo.email': 'Verificación de Correo',
  'memberList.validInfo.kyc': 'Verificación KYC',

  // Verification info tags
  'memberList.validInfo.realNameTag': 'Nombre Real',
  'memberList.validInfo.mobileTag': 'Móvil',
  'memberList.validInfo.emailTag': 'Correo',
  'memberList.validInfo.kycTag': 'KYC',
  'memberList.validInfo.verification': ' Verificación',

  // Risk level options
  'memberList.riskLevel.limitLogin': 'Límite de Inicio de Sesión',
  'memberList.riskLevel.limitDeposit': 'Límite de Depósito',
  'memberList.riskLevel.limitWithdraw': 'Límite de Retiro',
  'memberList.riskLevel.limitBonus': 'Límite de Bono',
  'memberList.riskLevel.suspiciousRisk': 'Riesgo Sospechoso',
  'memberList.riskLevel.normal': 'Normal',
  'memberList.riskLevel.sameIpRisk': 'Riesgo de IP Misma',
  'memberList.riskLevel.sameDeviceRisk': 'Riesgo de Dispositivo Mismo',
  'memberList.riskLevel.sameBankCardRisk': 'Riesgo de Tarjeta Bancaria Misma',
  'memberList.riskLevel.sameWalletRisk': 'Riesgo de Cartera Misma',

  // Quick date options
  'memberList.quickDate.today': 'Hoy',
  'memberList.quickDate.yesterday': 'Ayer',
  'memberList.quickDate.last7Days': 'Últimos 7 Días',
  'memberList.quickDate.last30Days': 'Últimos 30 Días',
  'memberList.quickDate.thisWeek': 'Esta Semana',
  'memberList.quickDate.lastWeek': 'Semana Pasada',
  'memberList.quickDate.thisMonth': 'Este Mes',
  'memberList.quickDate.lastMonth': 'Mes Pasado',

  // Login channel options
  'memberList.loginChannel.label': 'Canal de Inicio de Sesión',
  'memberList.loginChannel.placeholder': 'Seleccione canal de inicio de sesión',
  'memberList.loginChannel.all': 'Todos',
  'memberList.loginChannel.others': 'Otros',
  'memberList.loginChannel.web': 'Web',
  'memberList.loginChannel.androidApp': 'Aplicación Android',
  'memberList.loginChannel.androidH5': 'Android H5',
  'memberList.loginChannel.androidPwa': 'Android PWA',
  'memberList.loginChannel.iosH5': 'iOS H5',
  'memberList.loginChannel.iosPwa': 'iOS PWA',
  'memberList.loginChannel.iosApp': 'Aplicación IOS',

  // Units
  'memberList.unit.times': ' veces',
  'member.detail.modal.addRemark.content': 'Contenido de Nota',
  'member.detail.modal.addRemark.placeholder': 'Ingrese nota',
  'member.detail.modal.addRemark.isTop': 'Fijar en la Parte Superior',
  'member.detail.modal.addRemark.success': 'Nota agregada exitosamente',
  'member.detail.modal.addRemark.error': 'Falló al agregar nota',
  'member.detail.modal.editEmail.title': 'Correo',
  'member.detail.modal.editEmail.email': 'Correo',
  'member.detail.modal.editEmail.emailPlaceholder': 'Ingrese correo',
  'member.detail.modal.editEmail.emailError': 'Correo inválido',
  'member.detail.modal.editEmail.remark': 'Nota',
  'member.detail.modal.editEmail.remarkPlaceholder': 'Ingrese nota',
  'member.detail.modal.editEmail.success': 'Correo actualizado exitosamente',
  'member.detail.modal.editEmail.error': 'Falló al actualizar correo',
  'member.detail.modal.editEmail.emailExists': 'El correo ya existe',
  'member.detail.modal.editIdentity.title': 'Información de Identidad',
  'member.detail.modal.editIdentity.realName': 'Nombre Completo',
  'member.detail.modal.editIdentity.realNamePlaceholder': 'Ingrese nombre completo',
  'member.detail.modal.editIdentity.birthdayTime': 'Fecha de Nacimiento',
  'member.detail.modal.editIdentity.remark': 'Nota',
  'member.detail.modal.editIdentity.remarkPlaceholder': 'Ingrese nota',
  'member.detail.modal.editIdentity.success': 'Identidad actualizada exitosamente',
  'member.detail.modal.editIdentity.error': 'Falló al actualizar identidad',
  'member.detail.modal.editKyc.title': 'Actualizar KYC',
  'member.detail.modal.editKyc.legalName': 'Nombre Legal',
  'member.detail.modal.editKyc.legalNamePlaceholder': 'Ingrese nombre legal',
  'member.detail.modal.editKyc.birthDate': 'Fecha de Nacimiento',
  'member.detail.modal.editKyc.idCardUrl': 'Cédula de Identidad',
  'member.detail.modal.editKyc.success': 'KYC actualizado exitosamente',
  'member.detail.modal.editKyc.error': 'Falló al actualizar KYC',
  'member.detail.modal.editPhone.title': 'Número de Teléfono',
  'member.detail.modal.editPhone.phoneNumber': 'Número de Teléfono',
  'member.detail.modal.editPhone.phoneNumberPlaceholder': 'Ingrese número de teléfono',
  'member.detail.modal.editPhone.phoneNumberError': 'Número de teléfono inválido',
  'member.detail.modal.editPhone.remark': 'Nota',
  'member.detail.modal.editPhone.remarkPlaceholder': 'Ingrese nota',
  'member.detail.modal.editPhone.success': 'Teléfono actualizado exitosamente',
  'member.detail.modal.editPhone.error': 'Falló al actualizar teléfono',
  'member.detail.modal.editPhone.phoneExists': 'El teléfono ya existe',
  'member.detail.modal.editRiskLevel.title': 'Nivel de Riesgo',
  'member.detail.modal.editRiskLevel.riskLevel': 'Nivel de Riesgo',
  'member.detail.modal.editRiskLevel.riskLevelPlaceholder': 'Seleccione nivel de riesgo',
  'member.detail.modal.editRiskLevel.remark': 'Nota',
  'member.detail.modal.editRiskLevel.remarkPlaceholder': 'Ingrese nota',
  'member.detail.modal.editRiskLevel.success': 'Nivel de riesgo actualizado exitosamente',
  'member.detail.modal.editRiskLevel.error': 'Falló al actualizar nivel de riesgo',
  'member.detail.modal.editRiskLevel.limitLogin': 'Límite de Inicio de Sesión',
  'member.detail.modal.editRiskLevel.limitDeposits': 'Límite de Depósito',
  'member.detail.modal.editRiskLevel.limitWithdrawal': 'Límite de Retiro',
  'member.detail.modal.editRiskLevel.limitDiscount': 'Límite de Promoción',
  'member.detail.modal.editRiskLevel.potentialRisk': 'Riesgo Sospechoso',
  'member.detail.modal.editRiskLevel.sameIpRisk': 'Riesgo de IP Misma',
  'member.detail.modal.editRiskLevel.sameDeviceRisk': 'Riesgo de Dispositivo Mismo',
  'member.detail.modal.editRiskLevel.sameBankCardRisk': 'Riesgo de Tarjeta Bancaria Misma',
  'member.detail.modal.editRiskLevel.sameWalletRisk': 'Riesgo de Cartera Misma',
  'member.detail.modal.editRiskLevel.loginLimitType': 'Tipo de Límite de Inicio de Sesión',
  'member.detail.modal.editRiskLevel.loginLimitTypePlaceholder': 'Seleccione tipo de límite de inicio de sesión',
  'member.detail.modal.editRiskLevel.loginLimitTypeRequired': 'Seleccione tipo de límite de inicio de sesión',
  'member.detail.modal.resetPassword.title': 'Restablecer Contraseña',
  'member.detail.modal.resetPassword.confirmText': '¿Confirmar restablecimiento de contraseña?',
  'member.detail.modal.resetPassword.successTitle': 'Contraseña restablecida exitosamente',
  'member.detail.modal.resetPassword.successText': 'Nueva contraseña:',
  'member.detail.modal.resetPassword.okText': 'Entendido',
  'member.detail.modal.resetPassword.error': 'Falló al restablecer contraseña',
  'member.detail.modal.resetWithdrawPassword.title': 'Restablecer Contraseña de Retiro',
  'member.detail.modal.resetWithdrawPassword.confirmText': '¿Confirmar restablecimiento de contraseña de retiro?',
  'member.detail.modal.resetWithdrawPassword.successTitle': 'Contraseña restablecida exitosamente',
  'member.detail.modal.resetWithdrawPassword.successText': 'Nueva contraseña:',
  'member.detail.modal.resetWithdrawPassword.okText': 'Entendido',
  'member.detail.modal.resetWithdrawPassword.error': 'Falló al restablecer contraseña',
  'member.detail.basicInfo.memberAccount': 'Cuenta de Miembro',
  'member.detail.basicInfo.memberName': 'Nombre de Miembro',
  'member.detail.basicInfo.agentInviteCode': 'Código de Agente',
  'member.detail.basicInfo.isAppUser': 'Usuario de Aplicación',
  'member.detail.basicInfo.agentName': 'Agente Directo',
  'member.detail.basicInfo.rootInviter': 'Amigo Principal',
  'member.detail.basicInfo.sameAsParentInviter': 'Igual que el amigo superior',
  'member.detail.basicInfo.parentInviter': 'Amigo Superior',
  'member.detail.basicInfo.inviterCode': 'Código de Invitación de Amigo',
  'member.detail.basicInfo.generateInviterCode': 'Generar',
  'member.detail.basicInfo.generateInviterCodeSuccess': 'Código de invitación de amigo generado',
  'member.detail.basicInfo.generateInviterCodeFailed': 'Error al generar el código de invitación de amigo',
  'member.detail.basicInfo.riskLevel': 'Nivel de Riesgo',
  'member.detail.basicInfo.registerTime': 'Hora de Registro',
  'member.detail.basicInfo.registerSource': 'Fuente de Registro',
  'member.detail.basicInfo.limitLogin': 'Límite de Inicio de Sesión',
  'member.detail.basicInfo.limitDeposits': 'Límite de Depósito',
  'member.detail.basicInfo.limitWithdrawal': 'Límite de Retiro',
  'member.detail.basicInfo.limitDiscount': 'Límite de Promoción',
  'member.detail.userTypeSetting.title': 'Configuración de Tipo de Usuario',
  'member.detail.userTypeSetting.userType.label': 'Tipo de Usuario',
  'member.detail.userTypeSetting.userType.normal': 'Usuario Normal',
  'member.detail.userTypeSetting.userType.store': 'Usuario de Tienda Minorista',
  'member.detail.userTypeSetting.displayVersion.label': 'Versión de Visualización',
  'member.detail.userTypeSetting.displayVersion.required': 'Seleccione versión de visualización',
  'member.detail.userTypeSetting.displayVersion.placeholder': 'Seleccione versión de visualización',
  'member.detail.userTypeSetting.displayVersion.hint': 'Las reglas de versión son definidas por el sistema (ver mapeo abajo); seleccione la versión a asignar a este usuario.',
  'member.detail.userTypeSetting.version.v1': 'Versión 1 (ecasino)',
  'member.detail.userTypeSetting.version.v2': 'Versión 2 (ecasino + ebingo)',
  'member.detail.userTypeSetting.offering.egames': 'Juegos Electrónicos',
  'member.detail.userTypeSetting.offering.ebingo': 'E-Bingo',
  'member.detail.userTypeSetting.offering.sportsbook': 'Apuestas Deportivas',
  'member.detail.userTypeSetting.offering.traditional': 'Bingo Tradicional',
  'member.detail.userTypeSetting.cat.ebingo': 'bingo (excl. Bingo Pilipino en Vivo)',
  'member.detail.userTypeSetting.cat.traditional': 'Bingo Pilipino en Vivo (OTB)',
  'member.detail.userTypeSetting.excl.sgPoker': 'Póquer SG',
  'member.detail.userTypeSetting.excl.sgLive': 'Casino en Vivo SG',
  'member.detail.userTypeSetting.excl.none': 'Sin exclusiones',
  'member.detail.userTypeSetting.preview.includeTitle': 'Categorías visibles/buscables',
  'member.detail.userTypeSetting.preview.excludeTitle': 'Exclusiones (ocultas/no buscables)',
  'member.detail.userTypeSetting.preview.normalNote': 'Los usuarios normales acceden al catálogo completo en línea sin filtro de versión; el campo de versión de visualización está oculto.',
  'member.detail.userTypeSetting.mapping.name': 'Versión de Visualización',
  'member.detail.userTypeSetting.defaultHint': 'Los usuarios existentes se tratan como usuarios normales de forma predeterminada.',
  'member.detail.userTypeSetting.preview.title': 'Categorías de juego visibles y buscables por este usuario (vista previa)',
  'member.detail.userTypeSetting.preview.empty': 'Seleccione una versión de visualización para obtener vista previa de categorías disponibles',
  'member.detail.userTypeSetting.preview.all': 'Todas las Categorías',
  'member.detail.userTypeSetting.preview.liveNoSg': 'casino en vivo (excluyendo SG)',
  'member.detail.userTypeSetting.preview.pokerNoSg': 'póquer (excluyendo SG)',
  'member.detail.userTypeSetting.preview.bingoNoLive': 'bingo (excluyendo bingo en vivo de FBM)',
  'member.detail.userTypeSetting.annot.effect': 'Toma efecto en el próximo inicio de sesión',
  'member.detail.userTypeSetting.annot.searchCover': 'Los resultados de búsqueda usan el mismo filtro de categoría',
  'member.detail.userTypeSetting.annot.versionFilter': 'Filtrado por versión en el backend',
  'member.detail.userTypeSetting.mapping.title': 'Mapeo de versión a categoría de juego de plataforma (definido por sistema, solo referencia)',
  'member.detail.userTypeSetting.mapping.version': 'Versión',
  'member.detail.userTypeSetting.mapping.includes': 'Categorías Incluidas',
  'member.detail.userTypeSetting.mapping.excludes': 'Exclusiones',
  'member.detail.userTypeSetting.mapping.v1Excludes': 'Póquer SG y casino en vivo',
  'member.detail.userTypeSetting.mapping.v2Excludes': 'Póquer SG y casino en vivo; bingo en vivo de FBM',
  'member.detail.userTypeSetting.footer.permNote': 'El acceso a la entrada se controla mediante permisos de rol',
  'member.detail.userTypeSetting.save': 'Guardar',
  'member.detail.userTypeSetting.success': 'Tipo de usuario actualizado exitosamente',
  'member.detail.userTypeSetting.error': 'Falló al actualizar tipo de usuario',
  'member.detail.kycInfo.realName': 'Nombre Completo',
  'member.detail.kycInfo.birthDate': 'Fecha de Nacimiento',
  'member.detail.kycInfo.kycStatus': 'Estado KYC',
  'member.detail.kycInfo.email': 'Correo',
  'member.detail.kycInfo.phoneNumber': 'Número de Teléfono',
  'member.detail.kycInfo.mobileProvider': 'Proveedor Móvil',
  'member.detail.kycInfo.viewPhone': 'Ver Teléfono',
  'member.detail.kycInfo.viewEmail': 'Ver Correo Electrónico',
  'member.detail.kycInfo.fetchEmailError': 'No se pudo obtener el correo electrónico',
  'member.detail.kycInfo.mobileValid.verified': 'Verificado',
  'member.detail.kycInfo.mobileValid.unverified': 'No Verificado',
  'member.detail.kycInfo.emailValid.verified': 'Verificado',
  'member.detail.kycInfo.emailValid.unverified': 'No Verificado',
  'member.detail.kycInfo.simple.pending': 'KYC de Registro pendiente de revisión',
  'member.detail.kycInfo.whole.pending': 'KYC de Retiro pendiente de revisión',
  'member.detail.kycInfo..whole.pending': 'KYC de Retiro pendiente de revisión',
  'member.detail.kycInfo.simple.success': 'KYC de Registro exitoso',
  'member.detail.kycInfo.whole.success': 'KYC de Retiro exitoso',
  'member.detail.kycInfo.simple.failed': 'KYC de Registro falló',
  'member.detail.kycInfo.whole.failed': 'KYC de Retiro falló',
  'member.detail.kycInfo.simple.blacklist': 'Lista Negra KYC de Registro',
  'member.detail.kycInfo.whole.blacklist': 'Lista Negra KYC de Retiro',
  'member.detail.kycInfo.notSubmitted': 'No Presentado',
  'member.detail.vipInfo.upgradeGrow': 'Puntos VIP (Actualización)',
  'member.detail.vipInfo.retentionGrow': 'Puntos VIP (Retención)',
  'member.detail.vipInfo.vipLevel': 'Nivel VIP',
  'member.detail.vipInfo.vipGrow': 'Puntos VIP',
  'member.detail.vipInfo.noVipInfo': 'Sin Información VIP',
  'member.detail.vipInfo.fetchError': 'Falló al obtener información VIP',
  'member.detail.vipInfo.permanentRetention': 'Retención Permanente',
  'member.detail.countryArea.error': 'Falló al obtener código de área',
  'member.detail.memberInfo.error': 'Falló al obtener información de miembro',
  'member.detail.remarkInfo.noMemberSelected': 'Seleccione miembro',
  'member.detail.remarkInfo.remarkContent': 'Contenido de Nota',
  'member.detail.remarkInfo.isTop': 'Fijar en la Parte Superior',
  'member.detail.remarkInfo.createTime': 'Hora de Creación',
  'member.detail.remarkInfo.createUser': 'Creador',
  'member.detail.remarkInfo.operation': 'Operación',
  'member.detail.remarkInfo.delete': 'Eliminar',
  'member.detail.remarkInfo.cancelTop': 'Desfijar',
  'member.detail.remarkInfo.setTop': 'Fijar',
  'member.detail.remarkInfo.confirmDelete': '¿Confirmar eliminar nota?',
  'member.detail.remarkInfo.confirm': 'Confirmar',
  'member.detail.remarkInfo.cancel': 'Cancelar',
  'member.detail.remarkInfo.deleteSuccess': 'Nota eliminada exitosamente',
  'member.detail.remarkInfo.deleteError': 'Falló al eliminar nota',
  'member.detail.remarkInfo.topSuccess': 'Fijado exitosamente',
  'member.detail.remarkInfo.cancelTopSuccess': 'Desfijado exitosamente',
  'member.detail.remarkInfo.topError': 'Falló al fijar',
  'member.detail.remarkInfo.cancelTopError': 'Falló al desfijar',
  'member.detail.remarkInfo.yes': 'Sí',
  'member.detail.remarkInfo.no': 'No',
  'member.detail.common.noData': 'Sin Datos',
  'member.detail.common.dash': '-',
  'member.betting.columns.index': 'No.',
  'member.betting.columns.betTime': 'Hora de Apuesta',
  'member.betting.columns.betAmount': 'Cantidad de Apuesta',
  'member.betting.columns.winLossAmount': 'Ganancia/Pérdida',
  'member.betting.columns.platformCode': 'Nombre de Plataforma',
  'member.betting.columns.gameType': 'Tipo de Juego',
  'member.betting.gameTypes.1': 'Tragamonedas',
  'member.betting.gameTypes.2': 'En Vivo',
  'member.betting.gameTypes.3': 'Deportes',
  'member.betting.gameTypes.4': 'Lotería',
  'member.betting.gameTypes.5': 'Pesca',
  'member.betting.gameTypes.6': 'Cartas',
  'member.betting.gameTypes.7': '3D',
  'member.betting.gameTypes.10': 'Esports',
  'member.betting.gameTypes.12': 'Bingo',
  'member.betting.currentPageTotal': 'Total de Página Actual',
  'member.welfare.columns.claimTime': 'Hora de Reclamación',
  'member.welfare.columns.promotionName': 'Nombre de Promoción',
  'member.welfare.columns.promotionAmount': 'Cantidad',
  'member.welfare.columns.promotionTemplate': 'Plantilla',
  'member.welfare.columns.sender': 'Remitente',
  'member.welfare.columns.status': 'Estado',
  'member.welfare.status.0': 'Pendiente',
  'member.welfare.status.1': 'Completado',
  'member.welfare.status.2': 'Expirado',
  'member.trade.columns.transactionTime': 'Hora de Transacción',
  'member.trade.columns.type': 'Tipo',
  'member.trade.columns.details': 'Detalles',
  'member.trade.columns.beforeAmount': 'Cantidad Anterior',
  'member.trade.columns.amount': 'Cantidad',
  'member.trade.columns.afterAmount': 'Cantidad Posterior',
  'member.trade.columns.operator': 'Operador',
  'member.trade.types.1001': 'Depósito',
  'member.trade.types.1002': 'Retiro',
  'member.trade.types.3999': 'Bono Manual',
  'member.trade.types.3001': 'Bono de Actualización VIP',
  'member.trade.types.3002': 'Bono de Retención VIP',
  'member.trade.types.3003': 'Salario Semanal VIP',
  'member.trade.types.3004': 'Salario Mensual VIP',
  'member.trade.types.3005': 'Bono de Cumpleaños VIP',
  'member.trade.types.3006': 'Puntos de Actualización VIP',
  'member.trade.types.3007': 'Puntos de Retención VIP',
  'member.trade.types.3008': 'Puntos Diarios de Aplicación VIP',
  'member.trade.types.3009': 'Puntos Diarios H5 VIP',
  'member.trade.types.3010': 'Bono de Rebaja de Juego VIP',
  'member.trade.types.3011': 'Bono de Rebaja',
  'member.trade.types.3012': 'Bono de Registro',
  'member.trade.types.3013': 'Bono de Depósito',
  'member.trade.types.3014': 'Bono de Primer Depósito Diario',
  'member.trade.types.3015': 'Inicio de Sesión',
  'member.trade.types.3016': 'Recarga',
  'member.trade.types.3017': 'Bono de Código de Canje',
  'member.trade.types.3018': 'Bono de Giro de Suerte',
  'member.trade.types.3019': 'Bono de Cada Recarga',
  'member.trade.types.3030': 'Bono de Primer Depósito',
  'member.trade.types.3031': 'Bono de Actividad de Tabla de Clasificación',
  'member.trade.types.3020': 'Recompensa de Invitación',
  'member.trade.types.3021': 'Recompensa de Logro',
  'member.trade.types.3022': 'Recompensa Invitada',
  'member.trade.types.3023': 'Bono de Vinculación de Información',
  'member.trade.types.3024': 'Bono de Caja de Tesoro',
  'member.trade.types.3026': 'Lluvia de Paquetes Rojos',
  'member.trade.types.3028': 'Premio de Caja de Tesoro',
  'member.trade.types.3029': 'Bono de Nueva Rebaja',
  'member.trade.types.5001': 'Entrada Manual',
  'member.trade.types.5002': 'Salida Manual',
  'member.trade.types.5003': 'Entrada Manual (Sin Flujo)',
  'member.trade.types.5004': 'Salida Manual (Sin Flujo)',
  'member.trade.types.5005': 'Liquidación de Deuda Incobrable',
  'member.trade.types.5006': 'Depósito de Agente',
  'member.trade.types.5007': 'Transferencia de Agente',
  'member.trade.types.6001': 'Entrada de Juego',
  'member.trade.types.6002': 'Salida de Juego',
  'member.trade.types.7001': 'Canje de Puntos',
  'member.trade.types.OTHER': 'Otro',
  'member.point.columns.changeDate': 'Fecha de Cambio',
  'member.point.columns.changeType': 'Tipo de Cambio',
  'member.point.columns.beforePoints': 'Puntos Anteriores',
  'member.point.columns.changeAmount': 'Cantidad de Cambio',
  'member.point.columns.afterPoints': 'Puntos Posteriores',
  'member.point.columns.remark': 'Nota',
  'member.point.changeTypes.increase': 'Aumento',
  'member.point.changeTypes.decrease': 'Disminución',
  'member.point.manualAdjust.title': 'Ajustar Puntos',
  'member.point.manualAdjust.currentPoints': 'Puntos Actuales',
  'member.point.manualAdjust.adjustType': 'Tipo de Ajuste',
  'member.point.manualAdjust.adjustPoints': 'Ajustar Puntos',
  'member.point.manualAdjust.validDate': 'Fecha de Vencimiento',
  'member.point.manualAdjust.submitRemark': 'Nota',
  'member.point.manualAdjust.increasePoints': 'Aumentar Puntos',
  'member.point.manualAdjust.decreasePoints': 'Disminuir Puntos',
  'member.point.manualAdjust.placeholder': 'Ingrese',
  'member.point.manualAdjust.success': 'Ajuste exitoso',
  'member.point.manualAdjust.error': 'Ajuste falló',
  'member.point.manualAdjust.getPointsError': 'Falló al obtener puntos',
  'wallet.accountBalance.title': 'Cartera de Cuenta',
  'wallet.accountBalance.totalBalance': 'Saldo Total',
  'wallet.accountBalance.mainBalance': 'Cuenta Principal',
  'wallet.accountBalance.memberPoints': 'Puntos de Miembro',
  'wallet.accountBalance.noPlatformData': 'Sin Datos de Plataforma',
  'wallet.accountBalance.manualAdjust.title': 'Ajuste Manual',
  'wallet.accountBalance.manualAdjust.currency': 'Moneda',
  'wallet.accountBalance.manualAdjust.currencyPlaceholder': 'Seleccione moneda',
  'wallet.accountBalance.manualAdjust.adjustType': 'Tipo de Ajuste',
  'wallet.accountBalance.manualAdjust.adjustTypePlaceholder': 'Seleccione tipo',
  'wallet.accountBalance.manualAdjust.increaseAmount': 'Aumentar',
  'wallet.accountBalance.manualAdjust.decreaseAmount': 'Disminuir',
  'wallet.accountBalance.manualAdjust.amount': 'Cantidad',
  'wallet.accountBalance.manualAdjust.amountPlaceholder': 'Ingrese cantidad',
  'wallet.accountBalance.manualAdjust.increaseFlow': 'Aumentar Flujo',
  'wallet.accountBalance.manualAdjust.decreaseFlow': 'Disminuir Flujo',
  'wallet.accountBalance.manualAdjust.flowPlaceholder': 'Ingrese flujo',
  'wallet.accountBalance.manualAdjust.memoPayDeposit': 'Contar en Depósito/Retiro',
  // —— Refund on deduction ——
  'wallet.accountBalance.manualAdjust.refund.label': 'Reembolso de cuota',
  'wallet.accountBalance.manualAdjust.refund.checkbox': '¿Reembolsar cuota a las fuentes?',
  'wallet.accountBalance.manualAdjust.refund.hint': 'De forma predeterminada, la deducción completa va a la plataforma. Marque para dividir manualmente los reembolsos a las fuentes originales. Cada fila ≤ reembolsable de fuente; suma ≤ deducción; el resto va a la plataforma.',
  'wallet.accountBalance.manualAdjust.refund.detailTitle': 'Detalle de reembolso',
  'wallet.accountBalance.manualAdjust.refund.colSource': 'Fuente',
  'wallet.accountBalance.manualAdjust.refund.colRefundable': 'Saldo reembolsable',
  'wallet.accountBalance.manualAdjust.refund.colAlreadyRefunded': 'Reembolsado',
  'wallet.accountBalance.manualAdjust.refund.colRefund': 'Cantidad de reembolso',
  'wallet.accountBalance.manualAdjust.refund.totalRefund': 'Reembolso total',
  'wallet.accountBalance.manualAdjust.refund.totalDeduct': 'Deducción total',
  'wallet.accountBalance.manualAdjust.refund.platformResidual': 'Residual (a la plataforma)',
  'wallet.accountBalance.manualAdjust.refund.sourceOpUser': 'Usuario de Op',
  'wallet.accountBalance.manualAdjust.refund.sourceOpUserPlaceholder': 'Cuota de operador backend',
  'wallet.accountBalance.manualAdjust.refund.sourceL1': 'Agente L1',
  'wallet.accountBalance.manualAdjust.refund.sourceL2': 'Agente L2',
  'wallet.accountBalance.manualAdjust.refund.empty': 'Sin fuente reembolsable para este miembro/moneda',
  'wallet.accountBalance.manualAdjust.refund.errorRowExceed': '⚠ Una fila excede su saldo reembolsable de fuente',
  'wallet.accountBalance.manualAdjust.refund.errorSumExceed': '⚠ El reembolso total excede la deducción total',
  'wallet.accountBalance.manualAdjust.refund.fetchFail': 'Falló al cargar fuentes de reembolso',
  'wallet.accountBalance.manualAdjust.remark': 'Nota',
  'wallet.accountBalance.manualAdjust.remarkPlaceholder': 'Ingrese nota',
  'wallet.accountBalance.manualAdjust.confirm': 'Confirmar',
  'wallet.accountBalance.manualAdjust.cancel': 'Cancelar',
  'wallet.accountBalance.manualAdjust.success': 'Exitoso',
  'wallet.accountBalance.manualAdjust.error': 'Falló',
  'wallet.bankCards.title': 'Tarjetas Bancarias',
  'wallet.bankCards.bindTime': 'Hora de Vinculación',
  'wallet.bankCards.bankName': 'Banco',
  'wallet.bankCards.cardHolder': 'Titular de Tarjeta',
  'wallet.bankCards.cardNumber': 'Número de Tarjeta',
  'wallet.bankCards.status': 'Estado',
  'wallet.bankCards.enabled': 'Habilitado',
  'wallet.bankCards.disabled': 'Deshabilitado',
  'wallet.bankCards.actions.unbind': 'Desvincular',
  'wallet.bankCards.actions.enable': 'Habilitar',
  'wallet.bankCards.actions.disable': 'Deshabilitar',
  'wallet.bankCards.actions.confirmUnbind': 'Confirmar Desvinculación',
  'wallet.bankCards.actions.confirmUnbindContent': '¿Confirmar desvinculación de tarjeta?',
  'wallet.bankCards.actions.confirmEnable': 'Confirmar Habilitación',
  'wallet.bankCards.actions.confirmEnableContent': '¿Confirmar habilitación de tarjeta?',
  'wallet.bankCards.actions.confirmDisable': 'Confirmar Deshabilitación',
  'wallet.bankCards.actions.confirmDisableContent': '¿Confirmar deshabilitar tarjeta?',
  'wallet.bankCards.actions.unbindSuccess': 'Desvincular exitoso',
  'wallet.bankCards.actions.unbindError': 'Error al desvincular',
  'wallet.bankCards.actions.enableSuccess': 'Habilitación exitosa',
  'wallet.bankCards.actions.enableError': 'Error al habilitar',
  'wallet.bankCards.actions.disableSuccess': 'Deshabilitación exitosa',
  'wallet.bankCards.actions.disableError': 'Error al deshabilitar',
  'wallet.financialOverview.title': 'Resumen Financiero',
  'wallet.financialOverview.totalDeposit': 'Total Depósito',
  'wallet.financialOverview.totalWithdrawal': 'Total Retiro',
  'wallet.financialOverview.firstDeposit': 'Primer Depósito',
  'wallet.financialOverview.depositCount': 'Cantidad Depósitos',
  'wallet.financialOverview.withdrawalCount': 'Cantidad Retiros',
  'wallet.financialOverview.totalBonus': 'Total Bono',
  'wallet.financialOverview.firstDepositTime': 'Hora Primer Depósito',
  'wallet.financialOverview.lastDeposit': 'Último Depósito',
  'wallet.financialOverview.lastDepositTime': 'Hora Último Depósito',
  'wallet.financialOverview.historicalProfitLoss': 'Pérdida/Ganancia Histórica',
  'wallet.financialOverview.historicalProfitLossDesc1': 'Pérdida/Ganancia Histórica: Estadísticas de todos los datos de pérdida/ganancia de terceros antes de ayer.',
  'wallet.financialOverview.historicalProfitLossDesc2': 'Color de monto (consistente con la lógica de color de apuestas de los últimos siete días).',
  'wallet.financialOverview.historicalProfitLossDesc3': 'Rojo: Pérdida, Verde: Ganancia.',
  'wallet.financialOverview.totalBetFlowAmount': 'Total Apuesta Válida',
  'wallet.financialOverview.pointExchangeAmount': 'Monto Canje Puntos',
  'wallet.financialOverview.todayDepositAmount': 'Depósito Hoy',
  'wallet.financialOverview.todayWithdrawAmount': 'Retiro Hoy',
  'wallet.financialOverview.todayProfitAmount': 'Ganancia Hoy',
  'wallet.financialOverview.todayBetAmount': 'Apuesta Hoy',
  'wallet.financialOverview.todayBonusAmount': 'Bono Hoy (incl. Canje)',
  'wallet.financialOverview.fetchError': 'Error al obtener resumen financiero',
  'wallet.financialOverview.historicalProfitLossFetchError': 'Error al obtener pérdida/ganancia histórica',
  'wallet.walletAccounts.title': 'Información Billetera',
  'wallet.walletAccounts.bindTime': 'Hora Vinculación',
  'wallet.walletAccounts.walletType': 'Tipo Billetera',
  'wallet.walletAccounts.walletName': 'Nombre Billetera',
  'wallet.walletAccounts.walletAccount': 'Cuenta Billetera',
  'wallet.walletAccounts.usdtType': 'Tipo USDT',
  'wallet.walletAccounts.status': 'Estado',
  'wallet.walletAccounts.enabled': 'Habilitado',
  'wallet.walletAccounts.disabled': 'Deshabilitado',
  'wallet.walletAccounts.actions.unbind': 'Desvincular',
  'wallet.walletAccounts.actions.enable': 'Habilitar',
  'wallet.walletAccounts.actions.disable': 'Deshabilitar',
  'wallet.walletAccounts.actions.confirmUnbind': 'Confirmar Desvincular',
  'wallet.walletAccounts.actions.confirmUnbindContent': '¿Confirmar desvincular billetera?',
  'wallet.walletAccounts.actions.confirmEnable': 'Confirmar Habilitar',
  'wallet.walletAccounts.actions.confirmEnableContent': '¿Confirmar habilitar billetera?',
  'wallet.walletAccounts.actions.confirmDisable': 'Confirmar Deshabilitar',
  'wallet.walletAccounts.actions.confirmDisableContent': '¿Confirmar deshabilitar billetera?',
  'wallet.walletAccounts.actions.unbindSuccess': 'Desvincular exitoso',
  'wallet.walletAccounts.actions.unbindError': 'Error al desvincular',
  'wallet.walletAccounts.actions.statusUpdateSuccess': 'Estado actualizado',
  'wallet.walletAccounts.actions.statusUpdateError': 'Error al actualizar estado',
  'wallet.withdrawalHistory.title': 'Historial Retiros',
  'wallet.withdrawalHistory.remainingFlow': 'Apuesta Válida Restante',
  'wallet.withdrawalHistory.completedFlow': 'Apuesta Válida Completada',
  'wallet.withdrawalHistory.totalFlow': 'Total Apuesta Válida Requerida',
  'wallet.withdrawalHistory.manualAdjust.title': 'Ajuste Apuesta Válida',
  'wallet.withdrawalHistory.manualAdjust.currency': 'Moneda',
  'wallet.withdrawalHistory.manualAdjust.currencyPlaceholder': 'Seleccionar moneda',
  'wallet.withdrawalHistory.manualAdjust.adjustType': 'Tipo Ajuste',
  'wallet.withdrawalHistory.manualAdjust.adjustTypePlaceholder': 'Seleccionar tipo',
  'wallet.withdrawalHistory.manualAdjust.increaseFlow': 'Aumentar Apuesta Válida',
  'wallet.withdrawalHistory.manualAdjust.decreaseFlow': 'Reducir Apuesta Válida',
  'wallet.withdrawalHistory.manualAdjust.amount': 'Monto',
  'wallet.withdrawalHistory.manualAdjust.amountPlaceholder': 'Ingresar monto',
  'wallet.withdrawalHistory.manualAdjust.remark': 'Nota',
  'wallet.withdrawalHistory.manualAdjust.remarkPlaceholder': 'Ingresar nota',
  'wallet.withdrawalHistory.manualAdjust.confirm': 'Confirmar',
  'wallet.withdrawalHistory.manualAdjust.cancel': 'Cancelar',
  'wallet.withdrawalHistory.manualAdjust.success': 'Éxito',
  'wallet.withdrawalHistory.manualAdjust.error': 'Error',
  'wallet.withdrawalHistory.flowChange.title': 'Historial Apuesta Válida',
  'wallet.withdrawalHistory.flowChange.operationTime': 'Hora',
  'wallet.withdrawalHistory.flowChange.type': 'Tipo',
  'wallet.withdrawalHistory.flowChange.totalCompletedFlow': 'Total Apuesta Válida',
  'wallet.withdrawalHistory.flowChange.beforeFlow': 'Apuesta Válida Anterior',
  'wallet.withdrawalHistory.flowChange.flowChange': 'Cambio',
  'wallet.withdrawalHistory.flowChange.afterFlow': 'Apuesta Válida Posterior',
  'wallet.withdrawalHistory.flowChange.types.recharge': 'Depósito',
  'wallet.withdrawalHistory.flowChange.types.withdraw': 'Retiro',
  'wallet.withdrawalHistory.flowChange.types.bonus': 'Bono',
  'wallet.withdrawalHistory.flowChange.types.rebate': 'Rebaja',
  'wallet.withdrawalHistory.flowChange.types.manual': 'Manual',
  'wallet.withdrawalHistory.flowChange.types.game': 'Juego',
  'wallet.withdrawalHistory.flowChange.types.point': 'Punto',
  'wallet.withdrawalHistory.flowChange.types.unknown': 'Otro',
  'wallet.common.refresh': 'Actualizar',
  'wallet.common.takeBack': 'Recuperar',
  'wallet.common.manualAdjust': 'Ajuste Manual',
  'wallet.common.confirm': 'Confirmar',
  'wallet.common.cancel': 'Cancelar',
  'wallet.common.success': 'Éxito',
  'wallet.common.error': 'Error',
  'wallet.common.loading': 'Cargando...',
  'wallet.common.switchTabToLoad': 'Cambiar pestaña para cargar contenido',
  'wallet.common.searchMember': 'Ingresar cuenta miembro en buscador',
  'wallet.common.operations': 'Operaciones',
  'wallet.common.takeBackConfirm': '¿Seguro que desea recuperar a saldo de cuenta?',
  'wallet.common.takeBackWarning': 'Después de confirmar, se recuperará por lote. Verificar saldo de cuenta después.',
  'wallet.withdrawalHistory.flowExceedError': 'Ajuste apuesta válida no puede exceder apuesta válida restante',
  'member.gameAccountTrade.columns.transId': 'ID Transacción',
  'member.gameAccountTrade.columns.platformCode': 'Plataforma Juego',
  'member.gameAccountTrade.columns.gameType': 'Tipo Juego',
  'member.gameAccountTrade.columns.gameName': 'Nombre Juego',
  'member.gameAccountTrade.columns.gameCode': 'Código Juego',
  'member.gameAccountTrade.columns.eventTime': 'Hora Apuesta',
  'member.gameAccountTrade.columns.createTime': 'Hora Cambio',
  'member.gameAccountTrade.columns.before': 'Monto Anterior',
  'member.gameAccountTrade.columns.amount': 'Monto',
  'member.gameAccountTrade.columns.balance': 'Monto Posterior',
  'member.gameAccountTrade.columns.action': 'API',
  'member.gameAccountTrade.columns.status': 'Estado',
  'member.gameAccountTrade.status.success': 'Éxito',
  'member.gameAccountTrade.status.refund': 'Reembolso',
  'member.gameAccountTrade.search.platformPlaceholder': 'Todas Plataformas',
  'member.gameAccountTrade.search.platformAll': 'Todas Plataformas',
  'member.gameAccountTrade.search.last7Days': 'Últimos 7 Días',
  'member.gameAccountTrade.search.thisMonth': 'Este Mes',
  'member.gameAccountTrade.gameTypes.1': 'Tragamonedas',
  'member.gameAccountTrade.gameTypes.2': 'En Vivo',
  'member.gameAccountTrade.gameTypes.3': 'Deportes',
  'member.gameAccountTrade.gameTypes.4': 'Lotería',
  'member.gameAccountTrade.gameTypes.5': 'Pesca',
  'member.gameAccountTrade.gameTypes.6': 'Ajedrez',
  'member.gameAccountTrade.gameTypes.7': '3D',
  'member.gameAccountTrade.search.gameType': 'Tipo Juego',
  'member.gameAccountTrade.search.gamePlatform': 'Plataforma Juego',
  'member.gameAccountTrade.search.accountChangeTime': 'Hora Cambio Cuenta',
  'member.gameAccountTrade.search.betTime': 'Hora Apuesta',
  'member.gameAccountTrade.search.betStartTime': 'Hora Inicio Apuesta',
  'member.gameAccountTrade.search.betEndTime': 'Hora Fin Apuesta',
  'member.gameAccountTrade.validation.betTimeExceedError': '¡Rango hora apuesta no puede exceder rango hora cambio cuenta!',
  'member.gameAccountTrade.error.fetchFailed': 'Error al obtener transacciones cuenta juego:',

  // Member No Recharge List Page
  'memberNoRecharge.title': 'Lista Miembros Registrados Sin Depósito',
  'memberNoRecharge.registerTime': 'Hora Registro',
  'memberNoRecharge.memberAccount': 'Cuenta Miembro',
  'memberNoRecharge.memberLevel': 'Nivel Miembro',
  'memberNoRecharge.agentAccount': 'Cuenta Agente Superior',
  'memberNoRecharge.registerInfo': 'Información Registro',
  'memberNoRecharge.registerTimeLabel': 'Hora Registro',
  'memberNoRecharge.registerIp': 'IP Registro',
  'memberNoRecharge.rechargeCount': 'Cantidad Depósitos',
  'memberNoRecharge.withdrawCount': 'Cantidad Retiros',
  'memberNoRecharge.totalRecharge': 'Total Depósito',
  'memberNoRecharge.totalWithdraw': 'Total Retiro',
  'memberNoRecharge.firstRechargeTime': 'Hora Primer Depósito',
  'memberNoRecharge.action': 'Acción',
  'memberNoRecharge.view': 'Ver',
  'memberNoRecharge.query': 'Consultar',
  'memberNoRecharge.reset': 'Restablecer',
  'memberNoRecharge.export': 'Exportar',
  'memberNoRecharge.startDate': 'Fecha Inicio',
  'memberNoRecharge.endDate': 'Fecha Fin',
  'memberNoRecharge.selectTimeRange': 'Seleccionar rango fechas o esperar carga datos',
  'memberNoRecharge.exportingData': 'Exportando datos...',
  'memberNoRecharge.exportSuccess': 'Exportación exitosa',
  'memberNoRecharge.exportFailed': 'Error al exportar',
  'memberNoRecharge.requestFailed': 'Solicitud fallida',
  'memberNoRecharge.selectTimeRangeRequired': 'Seleccionar rango fecha registro',

  // Member Churn List Page Additional Fields
  'memberChurn.accountLabel': 'Cuenta',
  'memberChurn.nameLabel': 'Nombre',
  'memberChurn.nicknameLabel': 'Apodo',
  'memberChurn.registerTimeLabel': 'Hora Registro',
  'memberChurn.registerIpLabel': 'IP Registro',
  'memberChurn.lastRechargeTimeLabel': 'Hora Último Depósito',
  'memberChurn.caliberExplanation.title': 'Descripción Calibre Abandono',
  'memberChurn.caliberExplanation.rule1': 'Instrucciones Filtro (Hora Último Comportamiento)',
  'memberChurn.caliberExplanation.rule2': '• Filtrar individual o combinado: Último Depósito / Último Login / Última Apuesta (todos son hora "último" comportamiento usuario).',
  'memberChurn.caliberExplanation.rule3': '• Uso Tiempo:',
  'memberChurn.caliberExplanation.rule4': '– Solo completar "Fin" ⇒ Encontrar última hora ≤ esa fecha;',
  'memberChurn.caliberExplanation.rule5': '– Solo completar "Inicio" ⇒ Encontrar última hora ≥ esa fecha (aún activo recientemente);',
  'memberChurn.caliberExplanation.rule6': '– Completar "Inicio+Fin" ⇒ Encontrar última hora dentro ese rango.',
  'memberChurn.caliberExplanation.rule7': 'Ejemplos Calibre Único',
  'memberChurn.caliberExplanation.example1': '– Hoy 27/9, fin depósito=24/9 ⇒ Usuarios con último depósito ≤ 24/9;',
  'memberChurn.caliberExplanation.example2': '– Rango login 1/8–7/8 ⇒ Usuarios con último login entre 1/8–7/8;',
  'memberChurn.caliberExplanation.example3': '– Solo apuesta inicio=01/9 ⇒ Usuarios con última apuesta ≥ 01/9.',
  'memberChurn.caliberExplanation.rule8': 'Uso Combinado (Responder Preguntas Negocio Diferentes)',
  'memberChurn.caliberExplanation.example4': '– Depósito Y Login: ¿Retornó después depósito? (p. ej., última dep ago, último login sep?)',
  'memberChurn.caliberExplanation.example5': '– Depósito Y Apuesta: ¿Realmente consumió después depósito? (p. ej., última dep nueva, pero última apuesta vieja → depósito pero no juega)',
  'memberChurn.caliberExplanation.example6': '– Login Y Apuesta: ¿Apuesta al retornar? (p. ej., último login nuevo, última apuesta vieja → retención visita buena, retención consumo pobre)',
  'memberChurn.caliberExplanation.example7': '– Depósito Y Login Y Apuesta: Todos nuevos = usuarios activos alto valor; alguno viejo = recuperación dirigida.',
  'memberChurn.lastLoginStartTime': 'Hora Último Login (Inicio)',
  'memberChurn.lastLoginEndTime': 'Hora Último Login (Fin)',
  'memberChurn.lastBettingStartTime': 'Hora Última Apuesta (Inicio)',
  'memberChurn.lastBettingEndTime': 'Hora Última Apuesta (Fin)',
  'member.gameAccountTrade.validation.dateRangeExceedError': '¡Rango hora cambio cuenta no puede exceder 7 días!',

  // KycRecordAdd.tsx
  'member.detail.modal.addKyc.title': 'actualizar KYC',
  'kyc.add.form.basic.information': 'Información Básica',
  'kyc.add.form.fullName': 'Nombre Completo',
  'kyc.add.form.firstName': 'Nombre',
  'kyc.add.form.middleName': 'Segundo Nombre',
  'kyc.add.form.lastName': 'Apellido',
  'kyc.add.form.birth.date': 'Fecha Nacimiento',
  'kyc.add.form.upload.id': 'Cargar su Identificación',
  'kyc.add.form.upload.selfie': 'Selfie con su Identificación Enviada',
  'kyc.add.form.additional.information': 'Información Adicional',
  'kyc.add.form.birth.place': 'Lugar Nacimiento',
  'kyc.add.form.permanent.address': 'Domicilio Permanente',
  'kyc.add.form.current.address': 'Domicilio Actual',
  'kyc.add.form.nationality': 'Nacionalidad',
  'kyc.add.form.income.source': 'Fuente Ingresos',
  'kyc.add.form.work.nature': 'Naturaleza Trabajo',
  'kyc.add.form.upload.latest': 'Foto Reciente',

  // Silent Users List
  'memberSilent.title': 'Lista Usuarios Silenciosos',
  'memberSilent.noDepositDate': 'Fecha Sin Depósito',
  'memberSilent.noDepositDateTip': 'Último depósito anterior a esta fecha o vacío se considera "usuario silencioso"',
  'memberSilent.noDepositDateDescription': '"Fecha Sin Depósito" representa fecha referencia; "Silencioso" = último depósito anterior a esta fecha o vacío. Cuando "Hoy Entra Silencioso" seleccionado: si fecha histórica seleccionada, "hoy" = esa fecha; para coincidir tareas SMS, seleccionar "Últimos N días (hasta hoy)".',
  'memberSilent.selectDate': 'Seleccionar Fecha',
  'memberSilent.selectNoDepositDate': 'Seleccionar fecha sin depósito',
  'memberSilent.selectNoDepositDateRequired': 'Fecha sin depósito requerida',
  'memberSilent.isTodayEnterSilent': 'Hoy Entra Silencioso',
  'memberSilent.isTodayEnterSilentTip': 'Marcar para ver solo usuarios "hoy entra silencioso"; si fecha histórica seleccionada, "hoy" = esa fecha',
  'memberSilent.requireLogin': 'Requerir Login en Período',
  'memberSilent.loginStart': 'Hora Inicio Login',
  'memberSilent.loginEnd': 'Hora Fin Login',
  'memberSilent.requireBetting': 'Requerir Apuesta en Período',
  'memberSilent.bettingStart': 'Hora Inicio Apuesta',
  'memberSilent.bettingEnd': 'Hora Fin Apuesta',
  'memberSilent.vipLevels': 'Niveles VIP',
  'memberSilent.selectVipLevels': 'Seleccionar niveles VIP',
  'memberSilent.selectAllVip': 'Seleccionar Todo',
  'memberSilent.excludeOfficialUsers': 'Excluir Usuarios Oficiales',
  'memberSilent.excludeAllAgents': 'Excluir Todos Agentes',
  'memberSilent.excludeAgentIds': 'Excluir Agentes Específicos',
  'memberSilent.selectExcludeAgents': 'Seleccionar agentes a excluir (buscable, múltiple)',
  'memberSilent.query': 'Consultar',
  'memberSilent.reset': 'Restablecer',
  'memberSilent.export': 'Exportar',
  'memberSilent.exportingData': 'Exportando datos...',
  'memberSilent.exportSuccess': 'Exportación exitosa',
  'memberSilent.exportFailed': 'Error al exportar',
  'memberSilent.requestFailed': 'Solicitud fallida',
  'memberSilent.lastLoginTime': 'Hora Último Login',
  'memberSilent.currencyRequired': 'Seleccionar moneda',
  'memberSilent.lastRechargeTime': 'Hora Último Depósito',
  'memberSilent.lastBettingTime': 'Hora Última Apuesta',
  'memberSilent.totalRecharge': 'Total Depósito (Multi-moneda)',
  'memberSilent.tip': 'Consejo',
  // Risk Control Information
  'member.detail.riskControl.sameIpUsers': 'Usuarios Misma IP',
  'member.detail.riskControl.sameDeviceUsers': 'Usuarios Mismo Dispositivo',
  'member.detail.riskControl.sameBankCardUsers': 'Usuarios Misma Tarjeta Bancaria',
  'member.detail.riskControl.sameWalletUsers': 'Usuarios Misma Billetera',
  'member.detail.riskControl.ipAddress': 'Dirección IP',
  'member.detail.riskControl.ipRegion': 'Región IP',
  'member.detail.riskControl.deviceId': 'ID Dispositivo',
  'member.detail.riskControl.deviceType': 'Tipo Dispositivo',
  'member.detail.riskControl.bankAccountName': 'Nombre Cuenta Bancaria',
  'member.detail.riskControl.bankCardNumber': 'Número Tarjeta Bancaria',
  'member.detail.riskControl.walletAccount': 'Cuenta Billetera',
  'member.detail.riskControl.walletType': 'Tipo Billetera',
  'member.detail.riskControl.associatedAccounts': 'Cuentas Asociadas',
  'member.detail.riskControl.expand': 'Expandir',
  'member.detail.riskControl.allAccounts': 'Todas Cuentas Asociadas',
  'member.detail.riskControl.totalAccounts': 'Total Cuentas',
  'member.detail.riskControl.searchAccount': 'Buscar Cuenta',
  'member.detail.riskControl.noAccountsFound': 'Cuentas no encontradas',

  // Invite Friends List
  'inviterList.title': 'Lista Invitación Amigos',
  'inviterList.column.chainTime': 'Inicio de Cadena',
  'inviterList.column.lastInviteTime': 'Última Invitación',
  'inviterList.column.lineCount': 'Miembros de Línea Completa',
  'inviterList.column.belongAgent': 'Agente asignado',
  'inviterList.agentUnassigned': 'Sin asignar',
  'inviterList.editAgent': 'Editar',
  'inviterList.agentFilterPlaceholder': 'Todos (buscable)',
  'inviterList.topInviter': 'Principal',
  'inviterList.depth.level': 'Amigo de Nivel {{level}}',
  'inviterList.status.valid': 'Válido',
  'inviterList.status.notQualified': 'No Califica',
  'inviterList.tag.inviteeBlocked': 'Invitado Bloqueado',
  'inviterList.tag.inviterBlocked': 'Invitador Bloqueado',
  'inviterList.action.drill': 'Ver Subordinados',
  'inviterList.action.report': 'Informe',
  'inviterList.filter.account': 'Cuenta',
  'inviterList.filter.accountPlaceholder': 'Ingrese la cuenta del usuario',
  'inviterList.filter.tag': 'Etiqueta de Usuario',
  'inviterList.filter.currency': 'Moneda',
  'inviterList.filter.tagPlaceholder': 'p. ej. Promotor',
  'inviterList.inviter': 'Invitador',
  'inviterList.inviterPlaceholder': 'Ingresar cuenta invitador o UID',
  'inviterList.inviteCode': 'Código Invitación',
  'inviterList.inviteCodePlaceholder': 'Ingresar código invitación',
  'inviterList.inviteStatus': 'Estado Invitación',
  'inviterList.status.all': 'Todos',
  'inviterList.status.normal': 'Normal',
  'inviterList.status.blacklist': 'Lista Negra',
  'inviterList.search': 'Buscar',
  'inviterList.reset': 'Restablecer',
  'inviterList.export': 'Exportar',
  'inviterList.exporting': 'Exportando, esperar...',
  'inviterList.exportSuccess': 'Exportación exitosa',
  'inviterList.exportFailed': 'Error al exportar',
  'inviterList.inviteSettings': 'Configuración Invitación',
  'inviterList.searchHint': 'Completar al menos uno de invitador o código invitación.',
  'inviterList.registerTime': 'Hora Registro',
  'inviterList.inviteCount': 'Cantidad Invitaciones',
  'inviterList.validCount': 'Cantidad Válidas',
  'inviterList.depositUsers': 'Usuarios Depósito',
  'inviterList.metric.inviteCount': 'Cantidad Invitaciones',
  'inviterList.metric.validCount': 'Cantidad Válidas',
  'inviterList.metric.depositCount': 'Usuarios Depósito',
  'inviterList.metricValue': 'Valor',
  'inviterList.action': 'Acción',
  'inviterList.detail': 'Detalle',
  'inviterList.addBlacklist': 'Añadir a Lista Negra',
  'inviterList.removeBlacklist': 'Quitar de Lista Negra',
  'inviterList.total': 'Total {count} invitadores.',
  'inviterList.uid': 'UID',
  'inviterList.requestFailed': 'Solicitud fallida',
  'inviterList.setting': 'Configuración',
  'inviterList.delete': 'Eliminar',
  'inviterList.currentStatus': 'Estado Actual',
  'inviterList.currencySwitchHint': 'Cambio moneda afectará estadísticas y datos lista.',

  // Invitee
  'inviterList.invitee.title': 'Usuarios Invitados',
  'inviterList.invitee.account': 'Cuenta Miembro',
  'inviterList.invitee.memberId': 'Cuenta Miembro',
  'inviterList.invitee.memberIdPlaceholder': 'Ingresar cuenta miembro (ID Miembro)',
  'inviterList.invitee.status': 'Estado Invitado',
  'inviterList.invitee.level': 'Nivel',
  'inviterList.invitee.level.1': 'Amigo Nivel 1',
  'inviterList.invitee.level.2': 'Amigo Nivel 2',
  'inviterList.invitee.level.3': 'Amigo Nivel 3',
  'inviterList.invitee.level.n': 'Amigo de nivel {{level}}',
  'inviterList.inviteeStatus.valid': 'Válido',
  'inviterList.inviteeStatus.invalid': 'Inválido',
  'inviterList.inviteeStatus.blacklist': 'En Lista Negra',
  'inviterList.invitee.registerTime': 'Hora Registro',
  'inviterList.invitee.effectiveTime': 'Hora Efectiva',
  'inviterList.invitee.firstDepositAmount': 'Monto Primer Depósito',
  'inviterList.invitee.firstDepositTime': 'Hora Primer Depósito',
  'inviterList.invitee.totalDeposit': 'Monto Válido',
  'inviterList.invitee.totalFlow': 'Apuesta Válida Total',
  'inviterList.invitee.currentStatus': 'Estado Actual',
  'inviterList.invitee.timeMode': 'Selección Tiempo',
  'inviterList.invitee.timeMode.none': 'Ninguno',
  'inviterList.invitee.timeMode.register': 'Hora Registro',
  'inviterList.invitee.timeMode.effective': 'Hora Efectiva',
  'inviterList.invitee.startDate': 'Fecha Inicio',
  'inviterList.invitee.endDate': 'Fecha Fin',
  'inviterList.invitee.stats.depositUsers': 'Usuarios Válidos',
  'inviterList.invitee.stats.totalDeposit': 'Total Depósito',
  'inviterList.invitee.stats.totalFlow': 'Apuesta Válida Total',
  'inviterList.invitee.total': 'Total {count} usuarios invitados ({currency}).',
  'inviterList.invitee.loadMore': 'Mostrar más ({{loaded}} / {{total}} cargados)',

  // Invitee Setting
  'inviterList.inviteeSetting.title': 'Configuración Invitado',
  'inviterList.inviteeSetting.warning': 'Esta operación afectará relación invitación y distribución recompensa. Confirmar antes ejecutar.',
  'inviterList.inviteeSetting.actionType': 'Acciones Disponibles',
  'inviterList.inviteeSetting.setValid': 'Quitar de Lista Negra',
  'inviterList.inviteeSetting.setInvalid': 'Marcar como Lista Negra',
  'inviterList.inviteeSetting.actionHint': 'Marcar como Válido: Solo validar umbral depósito y límite tiempo. Marcar como Inválido: Tomar efecto inmediato y limpiar hora efectiva.',
  'inviterList.inviteeSetting.reason': 'Razón Operación',
  'inviterList.inviteeSetting.reasonPlaceholder': 'Ingresar razón operación (requerida)',
  'inviterList.inviteeSetting.reasonRequired': 'Razón operación requerida',
  'inviterList.inviteeSetting.history.title': 'Historial',
  'inviterList.inviteeSetting.history.time': 'Hora',
  'inviterList.inviteeSetting.history.action': 'Acción',
  'inviterList.inviteeSetting.history.operator': 'Operador',
  'inviterList.inviteeSetting.history.reason': 'Razón',
  'inviterList.inviteeSetting.history.add': 'Añadir Control Riesgo',
  'inviterList.inviteeSetting.history.remove': 'Quitar Control Riesgo',
  'inviterList.inviteeSetting.success': 'Operación exitosa',
  'inviterList.inviteeSetting.failed': 'Error en operación',

  // Blacklist
  'inviterList.blacklist.addTitle': 'Añadir a Lista Negra Invitación',
  'inviterList.blacklist.removeTitle': 'Quitar de Lista Negra Invitación',
  'inviterList.blacklist.warning': 'Esta operación afectará relación invitación y distribución recompensa. Confirmar antes ejecutar.',
  'inviterList.blacklist.reason': 'Razón Operación',
  'inviterList.blacklist.reasonPlaceholder': 'Ingresar razón operación (requerida)',
  'inviterList.blacklist.reasonRequired': 'Razón operación requerida',
  'inviterList.blacklist.history.title': 'Historial',
  'inviterList.blacklist.history.time': 'Hora',
  'inviterList.blacklist.history.action': 'Acción',
  'inviterList.blacklist.history.operator': 'Operador',
  'inviterList.blacklist.history.reason': 'Razón',
  'inviterList.blacklist.history.add': 'Añadir Control Riesgo',
  'inviterList.blacklist.history.remove': 'Quitar Control Riesgo',
  'inviterList.blacklist.addSuccess': 'Añadido a lista negra',
  'inviterList.blacklist.removeSuccess': 'Quitado de lista negra',
  'inviterList.blacklist.failed': 'Error en operación',

  // Invite Settings
  'inviterList.inviteSettings.title': 'Configuración Invitación',
  'inviterList.inviteSettings.systemStatus': 'Estado Función Sistema',
  'inviterList.inviteSettings.systemStatusHint': 'Solo controlado por backend, no mostrado a usuarios.',
  'inviterList.inviteSettings.enabled': 'Habilitado',
  'inviterList.inviteSettings.disabled': 'Deshabilitado',
  'inviterList.inviteSettings.effectiveTime': 'Hora Efectiva',
  'inviterList.inviteSettings.longTerm': 'Plazo Largo',
  'inviterList.inviteSettings.timeRange': 'Rango Tiempo Especificado',
  'inviterList.inviteSettings.shareDomain': 'Dominio Principal Enlace Compartir Frontend',
  'inviterList.inviteSettings.currencyConfigs': 'Configuraciones Moneda (Múltiple)',
  'inviterList.inviteSettings.currencyConfigsHint': 'Cada moneda tiene su propia "Definición Usuario Válido" (no puede compartir si montos difieren).',
  'inviterList.inviteSettings.addCurrencyConfig': 'Añadir Configuración Moneda',
  'inviterList.inviteSettings.currency': 'Moneda',
  'inviterList.inviteSettings.relatedPromo': 'Promoción Relacionada',
  'inviterList.inviteSettings.selectPromo': 'Seleccionar Nombre Promoción',
  'inviterList.inviteSettings.defaultPromo': 'Invitar Amigos (Por Defecto)',
  'inviterList.inviteSettings.depositThreshold': 'Umbral Depósito Acumulativo',
  'inviterList.inviteSettings.depositFlowThreshold': 'Umbral Apuesta Válida Acumulativo',
  'inviterList.inviteSettings.amount': 'Monto',
  'inviterList.inviteSettings.timeLimit': 'Límite Tiempo para Calificación',
  'inviterList.inviteSettings.timeLimit.afterRegister': 'Después Registro',
  'inviterList.inviteSettings.timeLimit.inActive': 'Completar dentro Período Activo',
  'inviterList.inviteSettings.days': 'Días',
  'inviterList.inviteSettings.tip': 'Consejo',
  'inviterList.inviteSettings.tipContent': '"Marcar como Válido" solo valida: umbral depósito y límite tiempo (N días después registro / completar dentro período activo).',
  'inviterList.inviteSettings.saveSuccess': 'Guardado exitoso',
  'inviterList.inviteSettings.saveFailed': 'Error al guardar',
  'inviterList.inviteSettings.duplicateCurrency': 'Moneda {currencies} tiene configuraciones duplicadas. Solo una configuración por moneda permitida',
  'inviterList.inviteSettings.currencyExists': 'Moneda {currency} ya tiene configuración. Solo una configuración por moneda permitida',

  // Bad Debt Records
  'member.badDebt.columns.badDebtTime': 'Hora Deuda Incobrable',
  'member.badDebt.columns.betOrderNo': 'No. Orden Apuesta',
  'member.badDebt.columns.externalBetOrderNo': 'No. Orden',
  'member.badDebt.columns.gamePlatform': 'Plataforma Juego',
  'member.badDebt.columns.gameType': 'Tipo Juego',
  'member.badDebt.columns.betTime': 'Hora Apuesta',
  'member.badDebt.columns.settleTime': 'Hora Liquidación',
  'member.badDebt.columns.betAmount': 'Monto Apuesta',
  'member.badDebt.columns.payoutAmount': 'Monto Pago',
  'member.badDebt.columns.badDebtAmount': 'Monto Deuda Incobrable (Por Cobrar)',
  'member.badDebt.columns.deductedAmount': 'Monto Deducido (Cobrado)',
  'member.badDebt.columns.undeductedAmount': 'Monto No Deducido (No Cobrado)',
  'member.badDebt.columns.badDebtStatus': 'Estado Deuda Incobrable',
  'member.badDebt.columns.lastDeductionTime': 'Hora Última Deducción',
  'member.badDebt.columns.operation': 'Operación',
  'member.badDebt.search.badDebtTime': 'Hora Deuda Incobrable',
  'member.badDebt.search.badDebtStatus': 'Estado Deuda Incobrable',
  'member.badDebt.search.gamePlatform': 'Plataforma Juego',
  'member.badDebt.search.gameType': 'Tipo Juego',
  'member.badDebt.search.betOrderNo': 'No. Orden Apuesta',
  'member.badDebt.search.externalBetOrderNo': 'No. Orden',
  'member.badDebt.search.externalBetOrderNoPlaceholder': 'Ingresar número orden',
  'member.badDebt.search.selectBadDebtStatus': 'Seleccionar Estado Deuda Incobrable',
  'member.badDebt.search.selectGamePlatform': 'Todos',
  'member.badDebt.search.selectGameType': 'Todos',
  'member.badDebt.search.betOrderNoPlaceholder': 'Ingresar',
  'member.badDebt.search.query': 'Consultar',
  'member.badDebt.search.refresh': 'Actualizar',
  'member.badDebt.search.export': 'Exportar',
  'member.badDebt.status.pending': 'Pendiente Deducción',
  'member.badDebt.status.partial': 'Parcialmente Deducida',
  'member.badDebt.status.settled': 'Liquidada',
  'member.badDebt.status.writtenOff': 'Eliminada',
  'member.badDebt.operation.viewDetail': 'Ver Detalle',
  'member.badDebt.detail.title': 'Detalle Deuda Incobrable',
  'member.badDebt.detail.basicInfo': 'Información Básica',
  'member.badDebt.detail.memberAccount': 'Cuenta Miembro',
  'member.badDebt.detail.platformName': 'Nombre Plataforma',
  'member.badDebt.detail.currency': 'Moneda',
  'member.badDebt.detail.gameName': 'Nombre Juego',
  'member.badDebt.detail.deductionHistory': 'Historial Deducción',
  'member.badDebt.detail.deductionTime': 'Hora Deducción',
  'member.badDebt.detail.badDebtAmount': 'Monto Deuda Incobrable',
  'member.badDebt.detail.deductAmount': 'Monto Deducir',
  'member.badDebt.detail.badDebtStatus': 'Estado Deuda Incobrable',
  'member.badDebt.detail.remark': 'Observación',
  'member.badDebt.writeOff.button': 'Eliminar',
  'member.badDebt.writeOff.confirmTitle': 'Confirmar Eliminación',
  'member.badDebt.writeOff.confirmContent': '¿Seguro que desea eliminar? Esta operación no se puede deshacer.',
  'member.badDebt.writeOff.defaultRemark': 'Eliminación Manual',
  'member.badDebt.message.viewDetailComingSoon': 'Función ver detalle próxima',
  'member.badDebt.message.dataPkCodeRequired': 'Código PK Datos no existe',
  'member.badDebt.message.fetchDetailFailed': 'Error al obtener detalles',
  'member.badDebt.message.writeOffSuccess': 'Eliminación exitosa',
  'member.badDebt.message.writeOffFailed': 'Error al eliminar',
  'member.badDebt.error.fetchFailed': 'Error al obtener datos deuda incobrable',
  'member.badDebt.message.selectMember': 'Seleccionar miembro primero',
  'member.badDebt.message.exporting': 'Exportando...',
  'member.badDebt.message.exportSuccess': 'Exportación exitosa',
  'member.badDebt.message.exportFailed': 'Error al exportar',
  // Common translations for bad debt detail modal
  'common.cancel': 'Cancelar',
  'common.confirm': 'Confirmar',
  'common.close': 'Cerrar',
  'common.loading': 'Cargando...',
  'common.noData': 'Sin Datos',

  // Deposit Member List Page
  'depositMemberList.title': 'Lista Miembros Depósito',
  'depositMemberList.subtitle': '(Además filtro tiempo, completar al menos una condición consulta)',
  'depositMemberList.searchWarning': 'Completar al menos una condición consulta',
  'depositMemberList.timeRequired': 'Seleccionar rango tiempo',
  'depositMemberList.currencyRequiredForRecharge': 'Seleccionar moneda al filtrar por cantidad o monto depósito',
  'depositMemberList.currencyRequiredForTimeType': 'Seleccionar moneda al filtrar por hora primer depósito u hora último depósito',
  'depositMemberList.timeType': 'Tipo Tiempo',
  'depositMemberList.lastRechargeTime': 'Hora Último Depósito',
  'depositMemberList.firstRechargeTime': 'Hora Primer Depósito',
  'depositMemberList.registerTime': 'Hora Registro',
  'depositMemberList.memberAccount': 'Cuenta Miembro',
  'depositMemberList.memberAccountLabel': 'Cuenta Miembro',
  'depositMemberList.memberAccountPlaceholder': 'Ingresar cuenta miembro',
  'depositMemberList.realName': 'Nombre Real',
  'depositMemberList.realNameLabel': 'Nombre Real',
  'depositMemberList.realNamePlaceholder': 'Ingresar nombre real',
  'depositMemberList.memberNameLabel': 'Nombre Miembro',
  'depositMemberList.agentAccount': 'Cuenta Agente',
  'depositMemberList.agentAccountPlaceholder': 'Ingresar cuenta agente',
  'depositMemberList.rechargeCount': 'Cantidad Depósitos',
  'depositMemberList.rechargeCountPlaceholder': 'Ingresar cantidad mínima depósitos',
  'depositMemberList.rechargeAmount': 'Monto Depósito',
  'depositMemberList.rechargeAmountPlaceholder': 'Ingresar monto mínimo depósito',
  'depositMemberList.excludeAgent': 'Excluir Agente',
  'depositMemberList.excludeAgentPlaceholder': 'Seleccionar agentes a excluir (buscable, multi-selección)',
  'depositMemberList.excludeAllAgent': 'Excluir Todos Agentes',
  'depositMemberList.excludeOfficialUser': 'Excluir Usuarios Oficiales',
  'depositMemberList.mobileValid': 'Usuarios Móvil Verificado',
  'depositMemberList.smsTask': 'Tarea SMS Relacionada',
  'depositMemberList.smsTaskPlaceholder': 'Seleccionar tarea SMS para filtrar',
  'depositMemberList.matchedUsers': 'usuarios coincidentes',
  'depositMemberList.search': 'Buscar',
  'depositMemberList.reset': 'Restablecer',
  'depositMemberList.export': 'Exportar',
  'depositMemberList.vipLevel': 'Nivel VIP',
  'depositMemberList.registerInfo': 'Información Registro',
  'depositMemberList.registerIp': 'IP Registro',
  'depositMemberList.depositCount': 'Cantidad Depósitos',
  'depositMemberList.firstDepositAmount': 'Monto Primer Depósito',
  'depositMemberList.firstDepositTime': 'Hora Primer Depósito',
  'depositMemberList.lastDepositAmount': 'Monto Último Depósito',
  'depositMemberList.lastDepositTime': 'Hora Último Depósito',
  'depositMemberList.totalDeposit': 'Total Depósito',
  'depositMemberList.totalWithdraw': 'Total Retiro',
  'depositMemberList.depositWithdrawDiff': 'Diferencia Depósito-Retiro',
  'depositMemberList.action': 'Acción',
  'depositMemberList.view': 'Detalles',
  // Pay Order History Modal
  'depositMemberList.payOrderHistory.title': 'Historial Orden Pago',
  'depositMemberList.payOrderHistory.fetchError': 'Error al obtener historial orden pago',
  'depositMemberList.payOrderHistory.orderNumber': 'Número Orden',
  'depositMemberList.payOrderHistory.amount': 'Monto',
  'depositMemberList.payOrderHistory.paymentMethod': 'Método Pago',
  'depositMemberList.payOrderHistory.paymentChannel': 'Canal Pago',
  'depositMemberList.payOrderHistory.createTime': 'Hora Creación',
  'depositMemberList.payOrderHistory.successTime': 'Hora Éxito',
  'depositMemberList.payOrderHistory.status': 'Estado',
  'depositMemberList.payOrderHistory.status.pending': 'Pendiente',
  'depositMemberList.payOrderHistory.status.paid': 'Pagado',
  'depositMemberList.payOrderHistory.status.expired': 'Expirado',
  'depositMemberList.payOrderHistory.status.invalid': 'Inválido',

  // VIP Member List page
  'vipMemberList.title': 'Lista Miembros VIP',
  'vipMemberList.timeRequired': 'Seleccionar rango tiempo',
  'vipMemberList.currencyRequiredForRecharge': 'Seleccionar moneda al filtrar por cantidad depósito, monto o cantidad retiro',
  'vipMemberList.currencyRequiredForTimeType': 'Seleccionar moneda al filtrar por hora último depósito',
  'vipMemberList.timeType': 'Tipo Tiempo',
  'vipMemberList.lastRechargeTime': 'Hora Último Depósito',
  'vipMemberList.firstRechargeTime': 'Hora Primer Depósito',
  'vipMemberList.registerTime': 'Hora Registro',
  'vipMemberList.memberAccount': 'Cuenta Miembro',
  'vipMemberList.memberAccountLabel': 'Cuenta',
  'vipMemberList.memberAccountPlaceholder': 'Ingresar cuenta miembro',
  'vipMemberList.realName': 'Nombre Real',
  'vipMemberList.realNameLabel': 'Nombre Real',
  'vipMemberList.realNamePlaceholder': 'Ingresar nombre real',
  'vipMemberList.memberNameLabel': 'Apodo',
  'vipMemberList.agentAccount': 'Cuenta Agente',
  'vipMemberList.agentAccountPlaceholder': 'Ingresar cuenta agente',
  'vipMemberList.rechargeCount': 'Cantidad Depósitos',
  'vipMemberList.rechargeCountPlaceholder': 'Ingresar cantidad mínima depósitos',
  'vipMemberList.rechargeAmount': 'Monto Depósito',
  'vipMemberList.rechargeAmountPlaceholder': 'Ingresar monto mínimo depósito',
  'vipMemberList.withdrawCountPlaceholder': 'Ingresar cantidad mínima retiros',
  'vipMemberList.excludeAgent': 'Excluir Agentes',
  'vipMemberList.excludeAgentPlaceholder': 'Seleccionar agentes a excluir',
  'vipMemberList.excludeAllAgent': 'Excluir Todos Agentes',
  'vipMemberList.excludeOfficialUser': 'Excluir Usuarios Oficiales',
  'vipMemberList.smsTask': 'Tarea SMS',
  'vipMemberList.smsTaskPlaceholder': 'Seleccionar tarea SMS para filtrar',
  'vipMemberList.search': 'Buscar',
  'vipMemberList.reset': 'Restablecer',
  'vipMemberList.export': 'Exportar',
  'vipMemberList.vipLevel': 'Nivel VIP',
  'vipMemberList.registerInfo': 'Información Registro',
  'vipMemberList.registerIp': 'IP Registro',
  'vipMemberList.lastDepositTime': 'Hora Último Depósito',
  'vipMemberList.totalDeposit': 'Total Depósito',
  'vipMemberList.totalWithdraw': 'Total Retiro',
  'vipMemberList.depositWithdrawDiff': 'Diferencia Depósito-Retiro',
  'vipMemberList.totalBetAmount': 'Total Apuesta',
  'vipMemberList.totalWinLoss': 'Total Ganancia/Pérdida',
  'vipMemberList.lastBetTime': 'Hora Última Apuesta',
  'vipMemberList.lastLoginTime': 'Hora Último Login',
  'vipMemberList.vipLevelTime': 'Hora Cambio Nivel VIP',
  'vipMemberList.action': 'Acción',
  'vipMemberList.view': 'Detalles',

  // Import Log Management
  'importLog.title': 'Gestión Registros Importación',
  'importLog.fileName': 'Nombre Archivo',
  'importLog.fileNamePlaceholder': 'Ingresar nombre archivo',
  'importLog.createTime': 'Hora Envío',
  'importLog.completeTime': 'Hora Completación',
  'importLog.totalCount': 'Total',
  'importLog.successCount': 'Exitoso',
  'importLog.failCount': 'Error',
  'importLog.status': 'Estado',
  'importLog.statusPending': 'Procesando',
  'importLog.statusComplete': 'Completado',
  'importLog.action': 'Acción',
  'importLog.viewDetail': 'Ver Detalle',
  'importLog.search': 'Buscar',
  'importLog.reset': 'Restablecer',
  'importLog.requestFailed': 'Consulta fallida',
  'importLog.detail.title': 'Detalle Importación',
  'importLog.detail.close': 'Cerrar',
  'importLog.detail.loading': 'Cargando...',
  'importLog.detail.headerFileName': 'Nombre Archivo Importación',
  'importLog.detail.headerOperator': 'Operador',
  'importLog.detail.headerCreateTime': 'Hora Envío',
  'importLog.detail.headerCompleteTime': 'Hora Completación',
  'importLog.detail.headerStatus': 'Estado Importación',
  'importLog.detail.memberAccount': 'Cuenta Miembro',
  'importLog.detail.memberAccountPlaceholder': 'Buscar nombre usuario fallido',
  'importLog.detail.failureReason': 'Razón Error',
  'importLog.detail.failureTitle': 'Detalles Error',
  'importLog.detail.hint': 'Nota: Solo cuentas usuario con error del último mes se retienen',
  'importLog.detail.noFailedRecords': 'Sin registros con error',
  'importLog.detail.noRecords': 'Sin registros importación',

  // Negative Profit Member List Page
  'negativeProfitMember.title': 'Lista Miembros Pérdida Negativa',
  'negativeProfitMember.exportWarning': 'Complete las condiciones de búsqueda antes de exportar',
  'negativeProfitMember.exportLoading': 'Exportando...',
  'negativeProfitMember.dateRangeHint': 'Por defecto ayer, resultados consulta son resumen datos rango fecha seleccionado (Historial = excluyendo hoy)',
  'negativeProfitMember.hint': '(Al menos una condición consulta debe completarse excepto filtro tiempo)',
  'negativeProfitMember.dateRange': 'Fecha Estadísticas',
  'negativeProfitMember.selectVipLevel': 'Seleccionar nivel VIP',
  'negativeProfitMember.selectAll': 'Seleccionar Todo',
  'negativeProfitMember.curDataPkCode': 'Moneda Juicio',
  'negativeProfitMember.curDataPkCodeRequired': 'Seleccionar moneda juicio',
  'negativeProfitMember.selectCurDataPkCode': 'Seleccionar moneda juicio',
  'negativeProfitMember.lossThreshold': 'Umbral Pérdida ≥',
  'negativeProfitMember.lossThresholdPlaceholder': 'Pérdida neta mínima 100',
  'negativeProfitMember.memberAccount': 'Cuenta Miembro',
  'negativeProfitMember.memberAccountPlaceholder': 'Ingresar cuenta miembro',
  'negativeProfitMember.vipLevel': 'Nivel VIP',
  'negativeProfitMember.agentAccount': 'Cuenta Agente Superior',
  'negativeProfitMember.agentAccountPlaceholder': 'Ingresar cuenta agente superior',
  'negativeProfitMember.minDepositCount': 'Cantidad Depósitos Histórico',
  'negativeProfitMember.minDepositCountPlaceholder': 'Ingresar cantidad depósitos',
  'negativeProfitMember.minDepositAmount': 'Monto Depósito Histórico',
  'negativeProfitMember.minDepositAmountPlaceholder': 'Ingresar monto depósito',
  'negativeProfitMember.minWithdrawCount': 'Cantidad Retiros Histórico',
  'negativeProfitMember.minWithdrawCountPlaceholder': 'Ingresar cantidad retiros',
  'negativeProfitMember.minWithdrawAmount': 'Monto Retiro Histórico',
  'negativeProfitMember.minWithdrawAmountPlaceholder': 'Ingresar monto retiro',
  'negativeProfitMember.loginChannel': 'Terminal Login',
  'negativeProfitMember.selectLoginChannel': 'Seleccionar terminal login',
  'negativeProfitMember.registerInfo': 'Información Registro',
  'negativeProfitMember.registerTime': 'Hora Registro',
  'negativeProfitMember.registerIp': 'IP de Registro',
  'negativeProfitMember.realName': 'Nombre Real',
  'negativeProfitMember.nickname': 'Apodo',
  'negativeProfitMember.depositCount': 'Cantidad de Depósitos Históricos',
  'negativeProfitMember.withdrawCount': 'Cantidad de Retiros Históricos',
  'negativeProfitMember.depositAmount': 'Depósito Total Histórico (Multi-Moneda)',
  'negativeProfitMember.withdrawAmount': 'Retiro Total Histórico (Multi-Moneda)',
  'negativeProfitMember.depositWithdrawDiff': 'Diferencia Depósito-Retiro Histórica (Multi-Moneda)',
  'negativeProfitMember.bettingAmount': 'Apuesta Total Histórica (Multi-Moneda)',
  'negativeProfitMember.profitLoss': 'Ganancia/Pérdida Total Histórica (Multi-Moneda)',
  'negativeProfitMember.totalProfitLoss': 'Ganancia/Pérdida Total Acumulada (Multi-Moneda)',
  'negativeProfitMember.lastLoginTime': 'Última Hora de Acceso',
  'negativeProfitMember.requestFailed': 'Consulta fallida',
  'negativeProfitMember.exportSuccess': 'Exportación exitosa',
  'negativeProfitMember.exportFailed': 'Exportación fallida',
  // 裂变用户查询页面
  'jeepneyUserList.title': 'Consulta de Usuario de Fisión',
  'jeepneyUserList.gameStatusAll': 'Todos',
  'jeepneyUserList.gameStatusReady': 'Listo',
  'jeepneyUserList.gameStatusPlaying': 'Jugando',
  'jeepneyUserList.gameStatusFailed': 'Fallido',
  'jeepneyUserList.timeType': 'Tipo de Tiempo',
  'jeepneyUserList.lastLoginTime': 'Última Hora de Acceso',
  'jeepneyUserList.lastAdvanceTime': 'Última Hora de Avance',
  'jeepneyUserList.memberAccount': 'Cuenta de Miembro',
  'jeepneyUserList.memberAccountPlaceholder': 'Ingrese la cuenta del miembro',
  'jeepneyUserList.accountLabel': 'Cuenta',
  'jeepneyUserList.memberAccountLabel': 'Cuenta de Miembro',
  'jeepneyUserList.memberRealNameLabel': 'Nombre Real',
  'jeepneyUserList.memberNicknameLabel': 'Apodo',
  'jeepneyUserList.realName': 'Nombre Real',
  'jeepneyUserList.realNamePlaceholder': '',
  'jeepneyUserList.realNameLabel': 'Nombre',
  'jeepneyUserList.nicknameLabel': 'Apodo',
  'jeepneyUserList.vipLevel': 'Nivel VIP',
  'jeepneyUserList.memberLevel': 'Nivel de Miembro',
  'jeepneyUserList.currentRound': 'Ronda Actual',
  'jeepneyUserList.currentStage': 'Etapa Actual',
  'jeepneyUserList.rechargeCount': 'Cantidad de Recargas',
  'jeepneyUserList.rechargeAmount': 'Monto de Recarga',
  'jeepneyUserList.settlementSuccessCount': 'Liquidación Exitosa',
  'jeepneyUserList.settlementFailureCount': 'Liquidación Fallida',
  'jeepneyUserList.inviteCount': 'Cantidad de Invitaciones',
  'jeepneyUserList.validInviteCount': 'Cantidad de Invitaciones Válidas',
  'jeepneyUserList.pointsExchangeCount': 'Cantidad de Cambios de Puntos',
  'jeepneyUserList.currency': 'Moneda',
  'jeepneyUserList.currencyAll': 'Todos',
  'jeepneyUserList.distributedAmount': 'Monto Distribuido',
  'jeepneyUserList.fuelCurrency': 'Moneda de Combustible',
  'jeepneyUserList.fuelCurrencyTitle': 'Detalles de Moneda de Combustible',
  'jeepneyUserList.viewDetail': 'Ver Detalles',
  'jeepneyUserList.fuelBalance': 'Saldo de Combustible',
  'jeepneyUserList.fuelEarned': 'Combustible Ganado',
  'jeepneyUserList.fuelConsumed': 'Combustible Consumido',
  'jeepneyUserList.fuelConsumedShort': 'Consumir',
  'jeepneyUserList.fuelEarnedShort': 'Ganar',
  'jeepneyUserList.fuelBalanceShort': 'Saldo',
  'jeepneyUserList.fuelItem': 'Artículo',
  'jeepneyUserList.fuelValue': 'Valor',
  'jeepneyUserList.fuelDate': 'Fecha',
  'jeepneyUserList.fuelMemberAccount': 'Cuenta de Miembro',
  'jeepneyUserList.fuelTransactionType': 'Tipo',
  'jeepneyUserList.fuelSourceType': 'Fuente',
  'jeepneyUserList.fuelSourceTypeLabel': 'Fuente de Recompensa',
  'jeepneyUserList.fuelTransactionTypeLabel': 'Tipo de Moneda',
  'jeepneyUserList.fuelAmount': 'Monto',
  'jeepneyUserList.fuelBalanceBefore': 'Antes',
  'jeepneyUserList.fuelBalanceAfter': 'Después',
  'jeepneyUserList.sourceTypeAll': 'Todos',
  'jeepneyUserList.sourceTypeStageConsume': 'Consumo de Etapa',
  'jeepneyUserList.sourceTypeRoundClear': 'Limpieza de Fin de Ronda',
  'jeepneyUserList.sourceTypeRecharge': 'Combustible de Recarga',
  'jeepneyUserList.sourceTypeInvite': 'Combustible de Invitación',
  'jeepneyUserList.sourceTypeEntry': 'Recompensa de Entrada',
  'jeepneyUserList.sourceTypeStage': 'Recompensa de Etapa',
  'jeepneyUserList.sourceTypePointsExchange': 'Cambio de Puntos',
  'jeepneyUserList.transactionTypeAll': 'Todos',
  'jeepneyUserList.transactionTypeIncome': 'Ingreso',
  'jeepneyUserList.transactionTypeExpense': 'Gasto',
  'jeepneyUserList.cashRewardTotal': 'Recompensa en Efectivo - Total',
  'jeepneyUserList.cashRewardDistributed': 'Recompensa en Efectivo - Distribuida',
  'jeepneyUserList.cashRewardDistributedTooltip': 'Costo de Actividad Real',
  'jeepneyUserList.totalPointsEarned': 'Total de Puntos Ganados',
  'jeepneyUserList.totalSpinTicketsEarned': 'Total de Boletos de Giro',
  'jeepneyUserList.returnRate': 'Tasa de Retorno',
  'jeepneyUserList.operation': 'Operación',
  'jeepneyUserList.rewardDetail': 'Detalle de Recompensa',
  'jeepneyUserList.search': 'Buscar',
  'jeepneyUserList.reset': 'Restablecer',
  'jeepneyUserList.export': 'Exportar',
  'jeepneyUserList.exportLoading': 'Exportando datos...',
  'jeepneyUserList.exportSuccess': 'Exportación exitosa',
  'jeepneyUserList.exportFail': 'Exportación fallida',
  'jeepneyUserList.hourlyUpdate': 'Actualizado cada hora',
  'jeepneyUserList.totalActivityCost': 'Costo Total de Actividad',
  'jeepneyUserList.totalReturnRate': 'Tasa de Retorno Total',
};
